<template>
  <section class="container" style="width: 100vw">
    <stockTopMenu windowId="deptCollectMoney" module="money"></stockTopMenu>
    <section
      class="content row"
      v-loading="loading"
      :element-loading-text="$t('deptCollectMoney.indexLoadingText')"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.2)">
      <main class="content-main">
        <noDataState
          class="main-info"
          v-if="!tableList.length && !loading"
          marginTop="280"
          :textDesc="$t('deptCollectMoney.indexNoDataText')"></noDataState>
        <section class="main-info" v-else>
          <grid-manager :option="gridOption"></grid-manager>
        </section>

        <section class="row align-center space-between bottom-tools">
          <div class="row align-center">
            <div v-if="ticketInfoList.length" class="ticket-div" @click="showTicketGoods = true">
              <div>{{ $t('deptCollectMoney.verifiedTicket') }}</div>
              <p>{{ ticketInfoList.length }}{{ $t('deptCollectMoney.ticketCount') }}</p>
              <span>{{ $t('deptCollectMoney.viewTicket') }}</span>
            </div>
            <template v-if="ticketInfoList.length && activeList.length">
              <div class="divider"></div>
              <div class="active-label">
                {{ $t('deptCollectMoney.promotionActivity') }}<i class="el-icon-right"></i>
              </div>
            </template>
            <div
              v-if="activeList.length"
              class="row align-center active-list"
              :class="[ticketInfoList.length ? '' : 'active-5']">
              <div
                v-for="item in activeList"
                :key="item.activityId"
                :class="['active-item', item.selectAct ? 'select-item' : '']"
                @click.stop="chooseActive(item)">
                <div class="row align-center space-between gift-add">
                  <div>
                    <div class="active-type" style="width:100px;">{{ item.typeDesc }}</div>
                    <div
                      class="active-title"
                      style="width: 140px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis" :title="item.activityName">
                      {{ item.activityName }}
                    </div>
                  </div>
                  <div>
                    <div
                      class="gift"
                      style="margin-left:8px;"
                      v-if="item.giftGoodInfos && item.giftGoodInfos.length"
                      @click.stop="giftAdd('gift', item)">
                      {{
                        item.checkGift && item.checkGift.length
                          ? $t('deptCollectMoney.viewGift')
                          : $t('deptCollectMoney.chooseGift')
                      }}<i class="el-icon-arrow-right"></i>
                    </div>
                    <div
                      class="add"
                      v-if="item.addGoodInfos && item.addGoodInfos.length"
                      @click.stop="giftAdd('add', item)">
                      {{
                        item.checkGive && item.checkGive.length
                          ? $t('deptCollectMoney.viewAddPurchase')
                          : $t('deptCollectMoney.chooseAddPurchase')
                      }}<i class="el-icon-arrow-right"></i>
                    </div>
                    <div class="show-goods" style="top: 10px" v-if="item.selectAct" @click.stop="showActGoods(item)">
                      {{ $t('deptCollectMoney.viewGoods') }}
                    </div>
                  </div>
                </div>
                <div class="row align-center space-center active-flag">
                  <i class="iconfont icon-gou"></i>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tableList.length" class="action-btn" @click="clearAll">
            {{ $t('deptCollectMoney.clearAction') }}
          </div>
        </section>
      </main>

      <aside class="content-aside">
        <section class="row align-center" style="margin-bottom: 10px;font-size: 16px;">
          <div>{{ $t('deptCollectMoney.typeAddedGoods') }}：</div>
          <div class="row tab-type">
            <div
              @click="changeSalesType('1')"
              :style="{ background: tabType === '1' ? '#067CF2' : '', color: tabType === '1' ? '#fff' : '#067CF2' }">
              {{ $t('deptCollectMoney.tabSell') }}
            </div>
            <div
              v-if="1===2"
              @click="changeSalesType('6')"
              :style="{ background: tabType === '6' ? '#067CF2' : '', color: tabType === '6' ? '#fff' : '#eb2f96' }">
              {{ $t('deptCollectMoney.tabExchange') }}
            </div>
            <div
              @click="changeSalesType('3')"
              :style="{ background: tabType === '3' ? '#067CF2' : '', color: tabType === '3' ? '#fff' : '#FF9000' }">
              {{ $t('deptCollectMoney.tabGift') }}
            </div>
          </div>
        </section>

        <section class="aside-scan row align-center" :style="{ border: isFocus ? '2px solid #F8475F' : '' }">
          <i class="iconfont icon-saomafukuan-" :style="{ color: isFocus ? '#C56209' : '#067CF2' }"></i>
          <span :style="{ background: isFocus ? '#C56209' : '#067CF2' }"></span>
          <input
            type="text"
            ref="scanAdd"
            v-model="searchWord"
            v-focusInput="1"
            :placeholder="$t('deptCollectMoney.scanPlaceholder')"
            @focus.stop="isFocus = true"
            @blur="isFocus = false"
            @keyup.enter="
              goodInfos.forEach((item, index) => {
                if (item.hasAlterPriceReview == 'Y') {
                  if (item.retailPrice) {
                    $set(goodInfos[index], 'realPrice', item.retailPrice)
                    $set(goodInfos[index], 'hasAlterPriceReview', 'N')
                  }
                }
              })
              operateItem('', '1', '', 'Y', '', 'ned')
            " />
        </section>
        <section class="row align-center">
          <div class="scan-tip">
            {{ $t('deptCollectMoney.scanTip') }}
            <p class="el-icon-caret-bottom"></p>
          </div>
        </section>

        <section class="aside-goodsno align-center">
          <div class="row align-center goods-input">
            <input
              :placeholder="$t('deptCollectMoney.goodsNoPlaceholder')"
              type="text"
              v-focusInput
              v-model="searchSpu"
              @keyup.enter="
                () => {
                  isUpdatePrice = false
                  goodInfos.forEach((item, index) => {
                    if (item.hasAlterPriceReview == 'Y') {
                      if (item.retailPrice) {
                        $set(goodInfos[index], 'realPrice', item.retailPrice)
                        $set(goodInfos[index], 'hasAlterPriceReview', 'N')
                      }
                    }
                  })
                  page = 1
                  queryGoodsNoList()
                }
              " />
            <span
              @click.prevent="
                () => {
                  isUpdatePrice = false
                  goodInfos.forEach((item, index) => {
                    if (item.hasAlterPriceReview == 'Y') {
                      if (item.retailPrice) {
                        $set(goodInfos[index], 'realPrice', item.retailPrice)
                        $set(goodInfos[index], 'hasAlterPriceReview', 'N')
                      }
                    }
                  })
                  page = 1
                  queryGoodsNoList()
                }
              "
              ><i class="el-icon-loading" v-show="spuLoading"></i>{{ $t('deptCollectMoney.searchText') }}</span
            >
            <div v-if="spulistVisable" class="spu-card">
              <div class="spu-card-list">
                <div class="row align-center spu-card-title">
                  <div>{{ $t('deptCollectMoney.spuGoodsNo') }}</div>
                  <div style="width:170px;">{{ $t('deptCollectMoney.spuGoodsName') }}</div>
                </div>
                <div
                  v-for="item in spuList"
                  :key="item.sup"
                  class="spu-list row align-center"
                  @click.stop="curSpu(item)">
                  <div>{{ item.goodsNo }}</div>
                  <div>{{ item.goodsName }}</div>
                </div>
              </div>
              <section class="row align-center space-center spu-page">
                <el-pagination
                  small
                  layout="prev, pager, next"
                  :pager-count="5"
                  :page-size="20"
                  :total="totalList"
                  :current-page="page - 0"
                  @current-change="getCurPage">
                </el-pagination>
                <p
                  @click="spulistVisable = false"
                  style="color: #f8475f; font-size: 14px; cursor: pointer; border-bottom: 1px solid #f8475f">
                  {{ $t('deptCollectMoney.spuClose') }}
                </p>
              </section>
            </div>
          </div>
        </section>
        <section class="aside-goodsno row align-center">
          <div
            class="goods-attr row align-center space-between"
            @click.stop="chooseColor"
            :style="{ background: colorModul ? '#FFE190' : '' }">
            {{ curColor || $t('deptCollectMoney.goodsColor') }}&nbsp;
            <i class="el-icon-arrow-down"></i>
            <div class="list-card" v-if="itemColor && colorModul">
              <div v-for="(item, c) in chooseColorList" :key="c" @click.stop="selectColor(item.value)">
                {{ item.value }}
              </div>
            </div>
          </div>
          <div
            class="goods-attr row align-center space-between"
            @click.stop="chooseSize"
            :style="{ background: sizeModule ? '#FFE190' : '' }">
            {{ curSize || $t('deptCollectMoney.goodsSize') }}&nbsp;
            <i class="el-icon-arrow-down"></i>
            <div class="list-card" v-if="itemSize && sizeModule">
              <div v-for="(item, s) in chooseSizeList" :key="s" @click.stop="selectSize(item.value)">
                {{ item.value }}
              </div>
            </div>
          </div>
        </section>

        <section class="row align-center text-center flex-wrap stock-sales">
          <!-- <div @click="salesQueryDialog = true" v-if="1===2">
            <p>{{ $t('deptCollectMoney.salesQuery') }}</p>
            <span>{{ $t('deptCollectMoney.salesQueryShortcut') }}</span>
          </div> -->
          <div @click="singleModule = true">
            <p>{{ $t('deptCollectMoney.goodsQuery') }}</p>
            <span>alt + c</span>
          </div>
          <!-- <div @click="chooseBadGoods">
            <p>{{ $t('deptCollectMoney.defectiveSale') }}</p>
            <span>{{ $t('deptCollectMoney.defectiveSaleShortcut') }}</span>
          </div> -->
          <div @click="chooseVip" class="none-margin-right">
            <p>{{ $t('deptCollectMoney.vipFunction') }}</p>
            <span>alt + x</span>
          </div>
          <div @click="hangAndGet">
            <p>{{ $t('deptCollectMoney.hangOrder') }}</p>
            <span>alt + f</span>
          </div>
          <!-- <div @click="openNewWindow('4')">
            <p>{{ $t('deptCollectMoney.customOrder') }}</p>
            <span>{{ $t('deptCollectMoney.customOrderShortcut') }}</span>
          </div> -->
          <!-- <div @click="openNewWindow('5')">
            <p>{{ $t('deptCollectMoney.priceAdjust') }}</p>
            <span>{{ $t('deptCollectMoney.priceAdjustShortcut') }}</span>
          </div> -->
          <div @click="stockAccountCardModule = true">
            <p>{{ $t('deptCollectMoney.stockCard') }}</p>
            <span>alt + g</span>
          </div>
          <!-- <div @click="openTicketHandel" class="none-margin-right">
            <p>{{ $t('deptCollectMoney.ticketVerify') }}</p>
            <span>{{ $t('deptCollectMoney.ticketVerifyShortcut') }}</span>
          </div> -->
          <div @click="timeFollowVisible = true">
            <p>{{ $t('deptCollectMoney.timeTarget') }}</p>
            <span>alt + r</span>
          </div>
        </section>

        <section class="sales-ording row align-center space-between" style="margin-bottom: 10px;margin-top:-10px;">
          <div class="row align-center text-center vip-card" :style="{height:curVip ?'100px':'54px'}">
            <template v-if="curVip">
              <div>
                <p>
                  <span style="width:160px; display:block;" :title="curVip.nickName" class="column">{{ curVip.nickName }}</span>
                  <span>{{ $t('deptCollectMoney.vipName') }}</span>
                </p>
                <i></i>
                <p>
                  <span style="width:160px;display:block;" :title="curVip.accountBalance || '0.00'" class="column">{{ curVip.accountBalance || '0.00' }}</span>
                  <span>{{ $t('deptCollectMoney.vipBalance') }}</span>
                </p>
              </div>
              <div>
                <p>
                  <span style="width:160px;display:block;" :title="curVip.phone" class="column">{{ curVip.phone }}</span>
                  <span>{{ $t('deptCollectMoney.vipPhone') }}</span>
                </p> 
                <i></i>
                <p>
                  <span style="width:160px;display:block;" :title="parseInt(curVip.integralBalance) || '0'" class="column">{{ parseInt(curVip.integralBalance) || '0' }}</span>
                  <span>{{ $t('deptCollectMoney.vipIntegral') }}</span>
                </p> 
              </div>
              <span @click="reChooseMember()" style="margin-right:10px;">{{ $t('deptCollectMoney.vipReselect') }}</span>
            </template>
            <template v-else>
              <div class="vip-default">
                <i class="iconfont icon-saoma"></i>
                <input
                  type="text"
                  ref="memberInput"
                  :style="{width:vipSetting&&vipSetting.memberCanQueryByMobile=='1'
                    &&(vipSetting.memberCanQueryByQrcode == '0'
                    ||!vipSetting.memberCanQueryByQrcode)?'335px':'176px'}"
                  v-model="memberValue"
                  v-focusInput="1"
                  :placeholder="
                    vipSetting&&vipSetting.memberCanQueryByQrcode=='1'
                    &&(vipSetting.memberCanQueryByMobile == '0'
                    ||!vipSetting.memberCanQueryByMobile)?`${$t('deptCollectMoney.vipScanCode')}`:vipSetting&&vipSetting.memberCanQueryByQrcode=='1'
                    &&vipSetting.memberCanQueryByMobile == '1'?`${$t('deptCollectMoney.vipScanOrPhone')}`:`${$t('deptCollectMoney.vipInputPhone')}`
                    "
                  @blur="queryBuyMember"
                  @keyup.enter="$event.target.blur()" />
              </div>
              <div class="vip-tip-text" v-if="vipSetting&&vipSetting.memberCanQueryByQrcode=='1'">{{ $t('deptCollectMoney.vipTip') }}</div>
            </template>
          </div>
        </section>

        <section class="sales-ording row align-center space-between" style="margin-bottom: 10px">
          <!-- <div class="row align-center item-card">
            <div
              class="item-value row align-center space-between">
              <span>{{ curSalesTitle }}</span>
              <i class="el-icon-caret-bottom" :style="salesVisiable ? 'transform: rotate(180deg);' : ''"></i>
            </div>
            <div class="item-options" v-if="salesVisiable">
              <div v-for="item in salesList" :key="item.id" @click.stop="saleshande(item)">
                {{ item.title }}
              </div>
            </div>
          </div> -->
          <div class="row align-center item-card" style="width: 100%" v-if="salesTypeId === '1'">
            <div class="item-value row align-center space-between" @click="showGuideList">
              <input
                ref="focusGuider"
                type="text"
                v-model="shopGuide"
                :placeholder="$t('deptCollectMoney.chooseShopGuide')"
                v-focusInput="1"
                :disabled="openState === 'Y'"
                @focus="shopListVisable = true"
                @input="queryGuide"
                @blur="guideBlur" />
              <i class="el-icon-caret-bottom" :style="shopListVisable ? 'transform: rotate(180deg);' : ''"></i>
            </div>
            <div class="item-options user-option" v-if="shopListVisable">
              <div
                v-for="item in shopList"
                :key="item.id"
                class="row align-center search-user"
                @click.stop="getcurUser(item)">
                <div>
                  <div class="user-avat">
                    <el-image v-if="item.avatar" :src="item.avatar" class="image"></el-image>
                    <div v-else>{{ item.realName.substring(0, 1) }}</div>
                  </div>
                </div>
                <div class="user-data">
                  <p>{{ item.phone }}</p>
                  <p>{{ item.realName }}</p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="row align-center item-card space-center show-allshop"
            style="width: 100%"
            v-if="salesTypeId === '2'"
            @click="guideModule = true">
            {{ $t('deptCollectMoney.chooseTeam') }}
          </div>
        </section>

        <section>
          <section class="ned-class" v-if="hasExchangeGoods">
            <div class="top">
              <img src="@/assets/images/ned.png" alt="" />{{ $t('deptCollectMoney.exchangeTitle') }}
            </div>
            <div class="center">
              {{ $t('deptCollectMoney.exchangeDesc') }}
            </div>
            <div class="bottom">
              <span style="color: #888">{{ $t('deptCollectMoney.exchangeTotalPrice') }}</span
              ><span style="color: #f84d65; font-size: 20px; margin-right: 30px; font-weight: 500"
                >{{ reduceResult.changeTotalPrice }}đ</span
              ><span style="color: #888">{{ $t('deptCollectMoney.exchangeTotalNum') }}</span
              ><span style="color: #f84d65; font-size: 20px; font-weight: 500">{{ reduceResult.changeNum }}</span>
            </div>
          </section>

          <section class="about-price">
            <div class="row align-center space-between price-line">
              <div>
                <span class="label-span">{{$t('deptCollectMoney.priceReceivable')}}：</span>
                <p class="value-p">{{ reduceResult.receivablePrice || '0' }}<i class="value-i">đ</i></p>
              </div>
              <div>
                <span class="label-span">{{$t('deptCollectMoney.priceSalesCount')}}：</span>
                <p class="value-p">{{ reduceResult.numTotal || '0' }}</p>
              </div>
            </div>
            <div class="price-line">
              <span class="label-span">{{$t('deptCollectMoney.priceTagTotal')}}：</span>
              <p class="value-p" style="color: #067cf2;">{{ reduceResult.tagPriceTotal || '0' }}<i class="value-i">đ</i></p>
            </div>
          </section>
        </section>

        <section class="aside-end text-center row align-center">
          <template v-if="quicklyPay">
            <div
              class="aside-finally column space-center"
              @mousedown="isDown = true"
              @mouseup="checkPublicState('normal')">
              <svg class="icon" aria-hidden="true">
                <use v-if="!isDown" xlink:href="#icon-jiesuan"></use>
                <use v-else xlink:href="#icon-jiesuan-down"></use>
              </svg>
              <div class="pay-btn-txt column align-center space-center">
                <div>{{ $t('deptCollectMoney.paySettle') }}</div>
                <p>alt + z</p>
              </div>
            </div>
            <div style="border: 2px solid #067cf2;margin-left: 10px;background: #fff;cursor: pointer;height:58px;" @click="checkPublicState('quickly')">
              <div style="color: #067cf2;font-size: 10px;margin-bottom: 5px;">{{ $t('deptCollectMoney.payQuick') }}</div>
              <span style="display:block; font-size: 10px;">{{ quicklyPay.name }}</span>
            </div>
          </template>
          <div
            v-else
            class="aside-finally column space-center"
            @mousedown="isDown = true"
            @mouseup="checkPublicState('normal')">
            <svg class="icon" aria-hidden="true">
              <use v-if="!isDown" xlink:href="#icon-jiesuan"></use>
              <use v-else xlink:href="#icon-jiesuan-down"></use>
            </svg>
            <div class="pay-btn-txt column align-center space-center">
              <div>{{ $t('deptCollectMoney.paySettle') }}</div>
              <p>alt + z</p>
            </div>
          </div>
        </section>
      </aside>
    </section>

    <ChooseGuige
      v-if="guigeModule"
      @close="closeGuigeModul"
      :curRow="curRow"
      :invoicesTypeId="ordingNature.id"></ChooseGuige>
    <OrdingPrice v-if="allPriceModule" @close="changeAllPrice" :priceAll="reduceResult.receivablePrice"></OrdingPrice>
    <Complimentaries v-if="giveModele" :currentActive="currentActive" @close="clsoePliment"></Complimentaries>
    <TradeInDialog v-if="tradeModule" :currentActive="currentActive" @close="closeTrade"></TradeInDialog>
    <ChangePrice
      v-if="priceModule"
      :alterPriceInfo="alterPriceInfo"
      :isAllOrding="isAllOrding"
      :invoicesTypeId="ordingNature.id"
      :salesTypeId="salesTypeId"
      :vipData="curVip"
      :activityInfo="activityInfo"
      :reduceResult="reduceResult"
      :list="goodInfos"
      :curGuider="guiderList"
      :couponInfoList="ticketInfoList"
      @close="cancelUpdatePrice"
      @setTabList="getState">
    </ChangePrice>
    <SingleRepertory
      v-if="singleModule"
      :init-value="curRow ? curRow['barCode'] : ''"
      @close="
        () => {
          this.singleModule = false
          this.curRow = null
          this.scanInputFocus()
        }
      "
      @skuData="getskuData">
    </SingleRepertory>
    <stockAccountCardVue v-if="stockAccountCardModule" @close="closeStockAccountCard"></stockAccountCardVue>
    <PayDialog
      v-if="payTypeDialog"
      :orderNature="{
        isUpdatePrice: isUpdatePrice,
        orderTypeId: ordingNature.id,
        salesTypeId: salesTypeId,
        guiderList: guiderList,
        tableList: goodInfos
      }"
      :vipData="curVip"
      :orderMoney="reduceResult"
      :activityInfo="activityInfo"
      :couponInfoList="ticketInfoList"
      @close="closePayDialog"
      @sendState="getState">
    </PayDialog>
    <VipDialog
      v-if="vipVisiable"
      :vipBtnVisible="vipBtnVisible"
      @close="
        vipVisiable = false
        scanInputFocus()
      "
      @sendVip="
        e => {
          this.curVip = e
        }
      "
      :curVip="curVip"></VipDialog>
    <SalesUserList
      v-if="guideModule"
      :curGuider="JSON.stringify(guiderList)"
      @close="
        guideModule = false
        scanInputFocus()
      "
      @sureBtn="getGanger"></SalesUserList>
    <hangRecord
      v-if="hangGetModule"
      @close="
        hangGetModule = false
        scanInputFocus()
      "
      @getOrder="getHangData"></hangRecord>
    <DoReceipts v-if="DoReceiptsModal" :title="$t('print.printTitle')" :webViewUrl="webViewUrl" @close="DoReceiptsModal = false"></DoReceipts>
    <SalesInquiry
      v-if="salesQueryDialog"
      @close="
        salesQueryDialog = false
        scanInputFocus()
      "></SalesInquiry>
    <SaleBadGoods
      v-if="badGoodsDialog"
      :tabList="goodInfos"
      @close="
        badGoodsDialog = false
        scanInputFocus()
      "
      @skuData="getskuData"
      @void="clearHandel"></SaleBadGoods>
    <PublicUser
      v-if="settingPublic"
      :open-state="openState"
      @close="
        settingPublic = false
        scanInputFocus()
      "
      @openSuccess="sureOpen"></PublicUser>

    <CheckTicket
      v-if="openTicket"
      :vipData="curVip"
      :goodsList="goodInfos"
      :couponList="ticketInfoList"
      :activityInfos="activeList"
      :checkObject="checkObject"
      :pinkerVisible="pinkerVisible"
      :checkActivityInfos="activityInfo"
      @close="
        openTicket = false
        checkObject = null
      "
      @open="openGiveCheck"
      @queryVip="getVipMobile">
    </CheckTicket>
    <TicketList
      v-if="showTicketGoods"
      :goodsList="goodInfos"
      :couponInfoList="ticketInfoList"
      @close="
        showTicketGoods = false
        currentCoupon = null
      "
      @re="reChoose"
      @update="updateInfo"
      @changeType="changeCheckType">
    </TicketList>
    <ChooseTicketGood
      v-if="ticketGoodsOpen"
      :type="ticketLogType"
      :goodsList="goodInfos"
      :couponInfo="currentCoupon"
      :couponInfoList="ticketInfoList"
      @closeDialog="ticketGoodsClose">
    </ChooseTicketGood>
    <TicketGive
      v-if="giveVisible"
      type="2"
      :couponInfoList="ticketInfoList"
      :couponInfo="currentCoupon"
      @close="giveVisible = false"
      @operate="operateList"></TicketGive>
    <ActiveGoodsList
      v-if="activeModule"
      :activeObject="currentActive"
      @close="
        activeModule = false
        scanInputFocus()
      "></ActiveGoodsList>

    <ScanPayWaiting
      v-if="scanWaiting"
      :ordingId="quicklyOrder.id"
      :payData="quicklyOrder['generateOrderPaymentInfoResp']['onLinePaymentInfos'] || []"
      @print="queryPrintData(quicklyOrder['innerSn'])"
      @close="closeScan">
    </ScanPayWaiting>

    <el-dialog
      :title="$t('deptCollectMoney.dialogTip')"
      :visible.sync="effectStateDialog"
      width="18%"
      :before-close="effectStateClose">
      <span style="font-size: 16px">{{ $t('deptCollectMoney.dialogVipRestrict') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="effectStateDialog = false">{{
          $t('deptCollectMoney.dialogConfirm')
        }}</el-button>
      </span>
    </el-dialog>
    <TimeTargetFollow v-if="timeFollowVisible" @close="timeFollowVisible = false"></TimeTargetFollow>
  </section>
</template>

<script>
import request from '@/libs/http'
import { ipcApiRoute, specialIpcRoute } from '@/api/main'
import { ipc } from '@/utils/ipcRenderer'
import Mousetrap from 'mousetrap'
import 'mousetrap/plugins/global-bind/mousetrap-global-bind'
import stockTopMenu from '@/components/stockTopMenu.vue'
import noDataState from '@/components/noDataState.vue'
import PayDialog from '@/components/PayDialog.vue'
import VipDialog from '@/views/vipModule/components/VipDialog'
import OrdingPrice from './components/OrdingPrice.vue'
import ChooseGuige from './components/ChooseGuige.vue'
import Complimentaries from './components/Complimentaries.vue'
import TradeInDialog from './components/TradeInDialog'
import ChangePrice from './components/ChangePrice.vue'
import OrdingDescript from './components/OrdingDescript.vue'
import SingleRepertory from './components/SingleRepertory.vue'
import ActiveGoodsList from './components/ActiveGoodsList.vue'
import hangRecord from './components/HangRecord.vue'
import SalesUserList from './components/SalesUserList.vue'
import DoReceipts from '@/views/salesRecord/components/DoReceipts.vue'
import SaleBadGoods from './components/SaleBadGoods.vue'
import stockAccountCardVue from './components/stockAccountCard.vue'
import SalesInquiry from './components/SalesInquiry.vue'
import PublicUser from './components/PublicUser'
import ScanPayWaiting from '@/components/ScanPayWaiting.vue'
import CheckTicket from './components/CheckTicket.vue'
import ChooseTicketGood from './components/ChooseTicketGood.vue'
import TicketList from './components/TicketList.vue'
import TicketGive from './components/TicketGive.vue'
import TimeTargetFollow from '@/views/deptCollectMoney/components/timeTargetFollow.vue'
import {
  operateGoodsNo,
  queryBrokerage,
  queryGoodsNo,
  queryInvoiceType,
  queryPaymentList,
  queryShoppGuide,
  submitStoreInvoice,
  queryRegisteredVipFlag
} from '@/libs/http/modules/posOrder.js'
import { crmVipDetail, printQueryVipInfo, crmQueryVipUnitConfig } from '@/libs/http/modules/vip'
import { closePublicOrder, openPublicOrderValid, queryPublicOrderEnableState } from '@/libs/http/modules/erp'

export default {
  components: {
    stockTopMenu,
    noDataState,
    PayDialog,
    OrdingPrice,
    ChooseGuige,
    Complimentaries,
    ChangePrice,
    OrdingDescript,
    SingleRepertory,
    ActiveGoodsList,
    VipDialog,
    SalesInquiry,
    hangRecord,
    SalesUserList,
    DoReceipts,
    TradeInDialog,
    SaleBadGoods,
    PublicUser,
    ScanPayWaiting,
    stockAccountCardVue,
    CheckTicket,
    ChooseTicketGood,
    TicketList,
    TicketGive,
    TimeTargetFollow
  },
  data() {
    return {
      timeFollowVisible: false,
      effectStateDialog: false,
      tabType: '1', //售赠退标识
      loading: false, //列表添加货品加载动画
      guigeModule: false, //选择规格弹窗
      payTypeDialog: false, //支付弹窗
      giveModele: false, //赠品弹窗
      tradeModule: false, //换购弹窗
      priceModule: false, //改价审批弹窗
      allPriceModule: false, //整单改价弹窗
      tableList: [], //货品数据列表
      singleModule: false, //单款库存弹窗
      curRow: null, //列表当前行数据
      isEdit: false, //是否编辑状态
      moreActive: false, //是否显示更多促销活动
      isDown: false, //买单按钮按下
      newAllPrice: '', //整单改价修改后整单的价格
      isAllOrding: false, //是否是整单改价
      vipVisiable: false, //会员弹窗
      curVip: null, //当前选中的会员
      isFocus: false, //条码输入框是否聚焦
      searchWord: '', //条码输入框的值
      searchSpu: '', //货号输入框的值
      page: 1, //货号查询到的货品当前页码
      spuList: [], //货号查询到的货品列表
      totalList: 0, //货号查询到的货品总数
      ordingTypeList: [], //订单性质列表
      ordingVisiable: false, //是否显示订单性质下拉列表
      ordingNature: null, //当前选中的订单性质
      salesVisiable: false, //是否显示业绩方式下拉列表
      salesTypeId: '1', //业绩方式主键
      curSalesTitle: this.$t('deptCollectMoney.personalPerformance'), //业绩方式描述
      salesList: [], //业绩方式列表数组
      shopGuide: '', //营业员输入框的值
      shopList: [], //营业员列表
      shopListVisable: false, //是否显示营业员下拉列表
      guideModule: false, //多选营业员弹窗
      guiderList: [], //当前选择的营业员
      hangGetModule: false, //挂单记录弹窗
      DoReceiptsModal: false, //打印小票弹窗
      reduceResult: {}, //汇总数据
      activeList: [], //匹配到的活动列表
      activityInfo: [], //选中的活动列表
      isAllowNegativeStocks: '', //是否允许负库存
      alterPriceInfo: {}, //改价信息
      rightMenu: false, //是否显示右键菜单
      goodInfos: [], //原货品信息
      isUpdatePrice: false, //是否改价
      sell: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/sell.png") : require("@/assets/images/vnSell.png"),
      give: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/give.png") : require("@/assets/images/vnGave.png"),
      back: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/return.png") : require("@/assets/images/vnReturn.png"),
      rite: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/rite.png") : require("@/assets/images/vnGift.png"),
      ned: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/ned.png") : require("@/assets/images/vnChange.png"),
      gridOption: {
        gridManagerName: 'collect-money',
        firstLoading: true,
        isCombSorting: true,
        supportAutoOrder: false,
        supportCheckbox: false,
        supportConfig: true,
        disableAutoLoading: true,
        disableBorder: true,
        disableLine: true,
        columnData: [
          {
            key: 'operationType',
            text: this.$t('gridManage.columnType'),
            align: 'center',
            width: '50px',
            template: () => {
              return `
                <div>
                  <img style="width:40px;height:40px;" v-if="row.operationType === '1'" :src="sell" />
                  <img style="width:40px;height:40px;" v-if="row.operationType === '2'" :src="give" />
                  <img style="width:40px;height:40px;" v-if="row.operationType === '4'" :src="back" />
                  <img style="width:40px;height:40px;" v-if="row.operationType === '3'" :src="rite" />
                  <img style="width:40px;height:40px;" v-if="row.operationType === '6'" :src="ned" />
                </div>
              `
            }
          },
          {
            key: 'goodsInfo',
            text: this.$t('gridManage.columnGoodsInfo'),
            align: 'center',
            width: '350px',
            template: () => {
              return `
                <div class="row align-center" style="text-align:left;">
                  <div style="position:relative;overflow:hidden;width:102px;height:92px;border-radius:4px;flex-shrink: 0;">
                    <el-image v-if="row.imageList && row.imageList[0]" style="width:102px;height:92px;border-radius:4px;float:left;" :preview-src-list="row.imageList" :src="row.imageList[0]"></el-image>
                    <div class="row align-center space-center" v-else style="width:102px;height:92px;border-radius:4px;text-align:center;color:#999;background:#f5f5f5;white-space: pre-wrap;">{{$t('gridManage.noGoodsImage')}}</div>
                    <div v-if="row.activityId || row.defectiveApplyId || row.isExchange === 'Y' || row.certificateId || row.dataType === 'other'"
                      style="
                      width:70px;height:18px;line-height:18px;position:absolute;top:10px;right:-16px;transform: rotate(45deg);text-align:center;
                      background: linear-gradient(-90deg, #EC4620, #F08702, #F7D400);color:#fff;font-size:8px;">
                      {{row.defectiveApplyId ? $t('gridManage.badGoods') : row.isExchange === 'Y' ? $t('gridManage.addBuy') : row.activityId ? $t('gridManage.activity') : $t('gridManage.writeOff')}}
                    </div>
                  </div>
                  <div v-if="row.dataType === 'other'" style="margin-left:10px;flex:1;">
                    <div style="font-size: 16px;margin-bottom: 8px;color: #000;">{{row.couponTypeName}}</div>
                    <div style="width: 100%;white-space: pre-wrap;">{{row.name}}</div>
                  </div>
                  <div v-else class="column space-around" style="margin-left:10px;flex:1;height: 90px;">
                    <div style="font-size:18px;color:#333;margin-top:-4px;">{{row.goodsName}}</div>
                    <div style="color:#999;">{{$t('gridManage.goodsNo')}}：{{row.goodsNo}}</div>
                    <div style="color:#999;">{{$t('gridManage.goodsBarCode')}}：{{row.barCode}}</div>
                  </div>
                </div>
              `
            }
          },
          {
            key: 'attr',
            text: this.$t('gridManage.columnAttr'),
            align: 'center',
            width: '220px',
            template: () => {
              return `
                <div v-if="row.dataType === 'other'" style="width: 160px;"></div>
                <div v-else>
                  <div v-if="row.attr" class="row space-between; align-center" style="width:160px;border:1px solid #DEEEF9;background:#fff;color:#333;line-height:26px;border-radius:2px;cursor:pointer;margin:0 auto;display:flex; justify-content: space-between;padding:0 7px;" @click="guigeHandel(row, index)">
                    <div>
                      <p>{{ row.attr[0].value }}</p>
                      <p>{{ $t('deptCollectMoney.goodsQuery_sizeLabel') }}：{{ row.attr[1].value }}</p>
                    </div>
                    <span class="el-icon-arrow-down" style="color:#067CF2;font-weight:bold;"></span>
                  </div>
                  <div style="color:#999;margin-top:10px;">{{$t('gridManage.goodsStock')}}：{{row.stock}}</div>
                </div>
              `
            }
          },
          {
            key: 'number',
            text: this.$t('gridManage.number'),
            align: 'center',
            width: '170px',
            template: () => {
              return `
                  <div class="row align-center space-center" v-if="row.dataType === 'other'" @click="reChoose(row)">
                    <div style="background:#067CF2;color:#fff;height:40px;line-height:40px;border-radius: 4px;width: 130px;">{{$t('gridManage.showOrRechoose')}}({{row.number}})</div>
                  </div>
                  <div v-else class="row align-center space-center">
                    <div style="background: #f3f3f3;width:40px;height:50px;line-height:50px;text-align:center;font-size:18px;border:1px solid #eee;color:#333;cursor:pointer;" @click.stop="minusHandel(row, index)">
                      <span class="el-icon-minus"></span>
                    </div>
                    <input type="text" :disabled="row.defectiveApplyId || row.operationType === '2'||(row.operationType === '3'&&row.giftRuleId) || row.isExchange === 'Y'" v-model="row.number" @focus="getDefault(row.number)" @input="checkValue(row, index)" @blur="blurHandel(row, index)" @keyup.enter="blurHandel(row, index)" style="width:60px;height:50px;line-height:50px;text-align:center;font-size:20px;border:1px solid #eee;border-left:none;color:#333;outline:none;background: #fff;" />
                    <div style="background:#067CF2;color:#fff;width:40px;height:50px;line-height:50px;text-align:center;font-size:18px;cursor:pointer;" @click.stop="plusHandel(row, index)">
                      <span class="el-icon-plus"></span>
                    </div>
                  </div>
                `
            }
          },
          {
            key: 'realPrice',
            text: this.$t('gridManage.realPriceUnit'),
            align: 'center',
            width: '170px',
            template: () => {
              return `
                <div class="row align-center space-center" @click.stop="cellTip(row)">

                  <div style="width:150px;">
                    <input :disabled="row.defectiveApplyId || row.operationType === '2' || row.isExchange === 'Y' || (row.operationType === '3' && row.giftRuleId) || row.operationType === '6' || row.dataType === 'other'" v-model="row.realPrice" @focus="getDefault(row.realPrice)" @input="checkValue(row, 'price')" @blur="getnewRow(row, index)" @keyup.enter="getnewRow(row, index)" style="border:1px solid #eee;outline:none;background:#fff;width:100%;text-align:center;height:46px;font-size:20px;border-radius:2px;" />
                    <div style="width:100%;height:20px;background:#ffa940;color:#fff;position:relative;" v-if="row.hasAlterPriceReview === 'Y' || row.isHasPremiumPrice === 'Y'">
                        <div style="margin-left:-10px;">
                          {{row.hasAlterPriceReview === 'Y' ? $t('gridManage.alreadyChangePrice') : $t('gridManage.autoRepairPrice')}}
                        </div>
                        <span v-if="row.hasAlterPriceReview === 'Y'" style="position:absolute;top:-1px;right:3px;" @click="recoverPriceMount(row, index,'recoverNed')">x</span>
                    </div>
                </div>
                <span style="color:#666;margin-right:8px;"></span>
                </div>
              `
            }
          },
          {
            key: 'retailPrice',
            text: this.$t('gridManage.retailPrice'),
            width: '110px',
            align: 'center',
            template: () => {
              return `
                <div class="row align-center space-center" style="font-size:18px">
                  {{row.retailPrice}}
                </div>
              `
            }
          },
          {
            key: 'tagPrice',
            text: this.$t('gridManage.tagPrice'),
            width: '110px',
            align: 'center',
            template: () => {
              return `
                <div class="row align-center space-center" style="font-size:18px">
                  {{row.tagPrice}}
                </div>
              `
            }
          },
          {
            key: 'agoRealPrice',
            text: this.$t('gridManage.initRealPrice'),
            width: '110px',
            align: 'center',
            template: () => {
              return `
                <div class="row align-center space-center" style="font-size:18px">
                  {{row.agoRealPrice}}
                </div>
              `
            }
          },
          {
            key: 'totalPrice',
            text: this.$t('gridManage.totalPrice'),
            align: 'center',
            template: () => {
              return `
                <div class="row align-center space-center" style="color:#F8475F;font-size:20px;">
                  {{ row.totalPrice }}
                </div>
              `
            }
          },
          {
            key: 'action',
            text: this.$t('gridManage.columnAction'),
            align: 'center',
            template: () => {
              return `
                <div v-if="row.dataType==='other'" @click="backOutTicket(row)" style="font-size:14px;color:#EAEAEA;cursor:pointer;color:#F8475F;">
                    <span style="border-bottom:1px solid #F8475F;">{{$t('gridManage.rebackWriteOff')}}</span>
                </div>
                <div v-else @click="delRow(row, index)" style="font-size:14px;color:#EAEAEA;cursor:pointer;color:#F8475F;">
                  <span style="border-bottom:1px solid #F8475F;">{{$t('gridManage.actionDelete')}}</span>
                </div>
              `
            }
          }
        ],
        ajaxData: this.showTable,
        menuHandler: list => {
          const menu = [
            {
              content: `
                <div class="row align-center space-between">
                  <div>{{$t('gridManage.rightshowStock')}}</div>
                  <span class="iconfont icon-shoucang" style="color:#6E6FEC;font-size:20px;"></span>
                </div>
              `,
              line: true,
              onClick: (gridManagerName, cell) => {
                let row = this.rightClickRow(cell)
                if (row) {
                  if (row.dataType === 'other') return
                  this.curRow = row
                  this.singleModule = true
                }
              }
            },
            {
              content: `
                <div class="row align-center space-between">
                  <div style="color:#F8475F;">{{$t('gridManage.rightDelect')}}</div>
                  <span class="iconfont icon-shanchu" style="color:#F8475F;font-size:16px;"></span>
                </div>
              `,
              line: false,
              onClick: (gridManagerName, cell) => {
                this.rightDelete(gridManagerName, cell)
              }
            }
          ]
          list = menu
          return list
        }
      },
      spuLoading: false,
      activeModule: false,
      currentActive: null,
      payLoading: false,
      itemColor: null,
      itemSize: null,
      skuInfoObj: null,
      colorModul: false,
      sizeModule: false,
      curSize: '',
      curColor: '',
      chooseSizeList: [],
      chooseColorList: [],
      spulistVisable: false,
      tableIndex: null,
      badGoodsDialog: false,
      webViewUrl: '',
      stockAccountCardModule: false,
      memberValue: '',
      cashierItem: null,
      openState: 'N',
      joinUser: '',
      settingPublic: false,
      salesQueryDialog: false,
      quicklyPay: null,
      isQuicklyPay: '',
      scanWaiting: false,
      quicklyLoading: false,
      quicklyOrder: null,
      isRevenue: '',

      openTicket: false,
      ticketGoodsOpen: false,
      ticketLogType: '',
      currentCoupon: null,
      showTicketGoods: false,
      giveVisible: false,
      ticketInfoList: [],
      checkObject: null,
      rowValurInit: '',
      vipBtnVisible: '',
      pinkerVisible: '',
      vipSetting:null
    }
  },

  created() {
    document.title = this.$t('salesRecord.openCollectMoney')
    this.cashierItem = JSON.parse(this.$cache.local.get('cashierDeskItem'))
    this.scanInputFocus()
    this.queryPayList()
    this.queryGuide()
    this.quicklyCode()
    this.queryInvoceList()
    this.queryBrokerageList()
    // this.cancelOpen()
    this.queryBtnPinker()
    this.vipQuerySetting()
    this.isRevenue = this.$cache.local.get('isRevenue')
  },
  mounted() {
    ipc.on(specialIpcRoute.window1ToWindow2, (event, arg) => {
      this.getHangData(arg)
    })
  },

  watch: {
    tableList: {
      handler() {
        if (!this.tableList.length) {
          this.goodInfos = []
          this.activeList = []
          this.activityInfo = []
          this.reduceResult = {}
          this.alterPriceInfo = {}
          this.ticketInfoList = []
          this.currentCoupon = null
          this.isAllOrding = false
          this.isUpdatePrice = false
          this.isAllowNegativeStocks = ''
        }
      }
    }
  },
  computed: {
    hasDisPrice() {
      return this.ticketInfoList.some(item => {
        return [0, 3].includes(item.couponType) || item.couponType === 2
      })
    },
    hasExchangeGoods() {
      return this.goodInfos.some(item => {
        return item.operationType === '6'
      })
    }
  },

  activated() {
    document.body.addEventListener('click', () => {
      this.salesVisiable = false
      this.ordingVisiable = false
      this.colorModul = false
      this.sizeModule = false
    })
  },

  methods: {
    async vipQuerySetting() {
      //查询会员配置
      this.vipSetting = await crmQueryVipUnitConfig()
    },
    scanInputFocus() {
      this.$nextTick(() => {
        this.$refs.scanAdd.focus()
      })
    },
    quicklyCode() {
      // 快捷键方法
      Mousetrap.bind(['alt+1', 'alt+1'], () => {
        //扫码聚焦
        this.scanInputFocus()
      })
      // Mousetrap.bind(['alt+s', 'alt+s'], () => {
      //   //销售查询
      //   this.salesQueryDialog = true
      // })
      Mousetrap.bind(['alt+v', 'alt+v'], () => {
        //客订记录
        this.openNewWindow('4')
      })
      Mousetrap.bind(['alt+b', 'alt+b'], () => {
        //调价通知
        this.openNewWindow('5')
      })
      Mousetrap.bind(['alt+r', 'alt+r'], () => {
        if (
          this.timeFollowVisible ||
          this.badGoodsDialog ||
          this.vipVisiable ||
          this.hangGetModule ||
          this.payTypeDialog ||
          this.singleModule ||
          this.priceModule
        ) {
          return
        } else {
          this.timeFollowVisible = true
        }
      })
      Mousetrap.bind(['alt+g', 'alt+g'], () => {
        //库存账卡
        if (
          this.badGoodsDialog ||
          this.vipVisiable ||
          this.hangGetModule ||
          this.payTypeDialog ||
          this.singleModule ||
          this.priceModule
        ) {
          return
        } else {
          this.stockAccountCardModule = true
        }
      })
      Mousetrap.bind(['alt+e', 'alt+e'], () => {
        //券码核销
        if (
          this.badGoodsDialog ||
          this.vipVisiable ||
          this.hangGetModule ||
          this.payTypeDialog ||
          this.singleModule ||
          this.priceModule ||
          this.stockAccountCardModule
        ) {
          return
        } else {
          this.openTicketHandel()
        }
      })
      Mousetrap.bind(['alt+c', 'alt+c'], () => {
        //单款库存
        if (
          this.badGoodsDialog ||
          this.vipVisiable ||
          this.payTypeDialog ||
          this.hangGetModule ||
          this.priceModule ||
          this.stockAccountCardModule
        ) {
          return
        } else {
          this.singleModule = true
        }
      })
      Mousetrap.bind(['alt+f', 'alt+f'], () => {
        //挂单取单
        if (
          this.badGoodsDialog ||
          this.vipVisiable ||
          this.payTypeDialog ||
          this.singleModule ||
          this.priceModule ||
          this.stockAccountCardModule
        ) {
          return
        } else {
          this.hangAndGet()
        }
      })
      Mousetrap.bind(['alt+q', 'alt+q'], () => {
        //次品销售
        if (
          this.singleModule ||
          this.payTypeDialog ||
          this.hangGetModule ||
          this.priceModule ||
          this.vipVisiable ||
          this.stockAccountCardModule
        ) {
          return
        } else {
          this.chooseBadGoods()
        }
      })
      Mousetrap.bind(['alt+x', 'alt+x'], () => {
        //会员功能
        if (
          this.badGoodsDialog ||
          this.singleModule ||
          this.payTypeDialog ||
          this.hangGetModule ||
          this.priceModule ||
          this.stockAccountCardModule
        ) {
          return
        } else {
          this.chooseVip()
        }
      })
      Mousetrap.bind(['alt+z', 'alt+z'], () => {
        //结算
        if (
          this.badGoodsDialog ||
          this.singleModule ||
          this.vipVisiable ||
          this.hangGetModule ||
          this.priceModule ||
          this.stockAccountCardModule
        ) {
          return
        } else {
          this.checkPublicState('normal')
        }
      })
    },
    queryBtnPinker() {
      queryRegisteredVipFlag()
        .then(res => {
          this.vipBtnVisible = res.registeredVipFlag
          this.pinkerVisible = res.pinkrRelationFlag
        })
        .catch(() => {})
    },
    queryPayList() {
      queryPaymentList({ isHasMember: this.curVip ? 'Y' : 'N' })
        .then(res => {
          this.quicklyPay = res.find(item => {
            return item.isDefault === 'Y' && item.type === '1'
          })
        })
        .catch(error => {})
    },
    queryGoodsNoList() {
      //查询货号列表
      if (!this.searchSpu)
        return this.$message({
          showClose: true,
          type: 'error',
          message: this.$t('deptCollectMoney.inputGoodsNoOrShortCode'),
          duration: 2000
        })
      this.spuLoading = true
      queryGoodsNo({
        keyword: this.searchSpu.trim(),
        pageSize: '20',
        page: this.page
      })
        .then(data => {
          if (
            !data ||
            JSON.stringify(data) === '{}' ||
            (data && !data.spuInfoList) ||
            (data && data.spuInfoList && !data.spuInfoList[0])
          ) {
            this.searchSpu = ''
            this.$message({
              showClose: true,
              type: 'error',
              message: this.$t('deptCollectMoney.noGoodsNoInfo'),
              duration: 2000
            })
          } else {
            this.spulistVisable = true
            this.spuList = data.spuInfoList
            this.totalList = +data.totalItem
          }
          this.spuLoading = false
        })
        .catch(error => {
          this.spuLoading = false
          this.$message({ showClose: true, type: 'error', message: error, duration: 2000 })
        })
    },

    changeSalesType(type) {
      this.scanInputFocus()
      if (this.tabType === type) return
      this.tabType = type
    },

    getCurPage(val) {
      //货号列表切换页码
      this.page = val
      this.queryGoodsNoList()
    },

    curSpu(item) {
      //当前选中货号
      this.searchSpu = item.goodsNo
      this.itemSize = item.spuInfoBean.attrList[0]
      this.itemColor = item.spuInfoBean.attrList[1]
      this.chooseSizeList = this.itemSize.valueList
      this.chooseColorList = this.itemColor.valueList
      this.skuInfoObj = item.spuInfoBean
      this.colorModul = true
      this.spulistVisable = false
    },

    chooseColor() {
      //颜色选择下拉框
      this.sizeModule = false
      if (!this.itemColor)
        return this.$message({
          showClose: true,
          type: 'error',
          message: this.$t('deptCollectMoney.chooseGoodsNo'),
          duration: 2000
        })
      this.colorModul = !this.colorModul
    },

    chooseSize() {
      //尺码选择下拉框
      this.colorModul = false
      if (!this.itemColor)
        return this.$message({
          showClose: true,
          type: 'error',
          message: this.$t('deptCollectMoney.chooseGoodsNo'),
          duration: 2000
        })
      this.sizeModule = !this.sizeModule
    },

    resetColorSize() {
      //重置货号选择相关信息
      this.searchSpu = ''
      this.curColor = ''
      this.curSize = ''
      this.keyword = ''
      this.itemSize = null
      this.itemColor = null
      this.skuInfoObj = null
      this.spuList = []
      this.chooseSizeList = []
      this.chooseColorList = []
    },

    selectColor(val) {
      //选择颜色
      this.curColor = val
      this.colorModul = false
      let curArray = []
      this.skuInfoObj.storeSkuInfoBeanList.forEach(item => {
        item.attrList.forEach(list => {
          if (this.curSize) {
            if (
              this.itemColor &&
              list.code === this.itemColor.code &&
              list.value === this.curColor &&
              this.curSize === item.attrList[1].value
            ) {
              this.resetColorSize()
              this.operateItem(item.barCode)
            }
          }
          if (this.itemColor && list.code === this.itemColor.code && list.value === this.curColor) {
            curArray.push(item)
          }
        })
      })
      let clickArr = curArray.map(item => {
        return item.attrList[1].value
      })
      if (!this.itemSize) return
      let newList = this.itemSize.valueList.filter(item => {
        return clickArr.includes(item.value)
      })
      this.chooseSizeList = newList
      if (!this.curSize) {
        this.sizeModule = true
      }
    },

    selectSize(val) {
      //选择尺码
      this.curSize = val
      this.sizeModule = false
      let curArray = []
      this.skuInfoObj.storeSkuInfoBeanList.forEach(item => {
        item.attrList.forEach(list => {
          if (this.curColor) {
            if (
              this.itemSize &&
              list.code === this.itemSize.code &&
              list.value === this.curSize &&
              this.curColor === item.attrList[0].value
            ) {
              this.resetColorSize()
              this.operateItem(item.barCode)
            }
          }
          if (this.itemSize && list.code === this.itemSize.code && list.value === this.curSize) {
            curArray.push(item)
          }
        })
      })
      let clickArr = curArray.map(item => {
        return item.attrList[0].value
      })
      if (!this.itemColor) return
      let newList = this.itemColor.valueList.filter(item => {
        return clickArr.includes(item.value)
      })
      this.chooseColorList = newList
      if (!this.curColor) {
        this.colorModul = true
      }
    },

    async openNewWindow(type) {
      //打开新窗口
      if (type === '1') {
        let options = {
          type: 'vue',
          content: '/salesRecord',
          windowName: this.$t('deptCollectMoney.salesRecordWindowName'),
          winId: 'salesRecord'
        }
        ipc.invoke(ipcApiRoute.createWindow, options).then(r => {})
      }
      if (type === '2') {
        let options = {
          type: 'vue',
          content: '/timeQuantum',
          windowName: this.$t('deptCollectMoney.timeQuantumWindowName'),
          winId: 'timeQuantum'
        }
        ipc.invoke(ipcApiRoute.createWindow, options).then(r => {})
      }
      if (type === '3') {
        let options = {
          type: 'vue',
          content: '/performanceCalendar',
          windowName: this.$t('deptCollectMoney.performanceCalendarWindowName'),
          winId: 'performanceCalendar'
        }
        ipc.invoke(ipcApiRoute.createWindow, options).then(r => {})
      }
      if (type === '4') {
        let options = {
          type: 'vue',
          content: '/customerOrder',
          windowName: this.$t('deptCollectMoney.customerOrderWindowName'),
          winId: 'customerOrder'
        }
        ipc.invoke(ipcApiRoute.createWindow, options).then(r => {})
      }
      if (type === '5') {
        let options = {
          type: 'vue',
          content: '/priceAdjustmentNotice',
          windowName: this.$t('deptCollectMoney.priceAdjustmentNoticeWindowName'),
          winId: 'priceAdjustmentNotice'
        }
        ipc.invoke(ipcApiRoute.createWindow, options).then(r => {})
      }
    },

    chooseBadGoods() {
      //选择次品
      let res = this.tableList.some(item => {
        return !item.defectiveApplyId
      })
      if (res || this.ticketInfoList.length) {
        return this.$message({
          showClose: true,
          type: 'error',
          message: this.$t('deptCollectMoney.cannotAddDefectiveGoods'),
          duration: 2000
        })
      }
      this.badGoodsDialog = true
    },

    clearHandel(e) {
      //次品作废回调清空对应列表数据
      let index = this.tableList.findIndex(item => {
        return item.barCode === e.barCode && item.realPrice === e.suggestPrice
      })
      if (index !== -1) {
        let obj = {
          index: index,
          barCode: this.tableList[index].barCode,
          sku: this.tableList[index].sku,
          number: this.tableList[index].number * -1,
          operationType: this.tableList[index].operationType,
          alterGoodsWay: '4',
          defectiveId: this.tableList[index].defectiveApplyId
        }
        this.operateItem('', '4', obj)
      }
    },

    chooseVip() {
      //选择会员功能
      this.vipVisiable = true
    },

    hangAndGet() {
      //挂单取单操作
      if (this.tableList.length) {
        let tipStr = ''
        if (this.ticketInfoList.length) {
          tipStr = this.$t('deptCollectMoney.hangOrderWithCouponTip')
        } else {
          tipStr = this.$t('deptCollectMoney.confirmHangOrder')
        }
        this.$confirm(tipStr, this.$t('deptCollectMoney.hangOrderConfirmTitle'))
          .then(() => {
            let shopArr = this.guiderList.map(item => {
              return item.id
            })
            this.loading = true
            submitStoreInvoice({
              type: '1',
              source: '2',
              terminalId: this.cashierItem ? this.cashierItem.id : '',
              orderTypeId: this.ordingNature.id,
              brokerage: this.salesTypeId,
              crmVipId: this.curVip ? this.curVip.id : '',
              checkActivityInfos: this.activityInfo,
              isAlterpriceReview: this.isUpdatePrice ? 'Y' : 'N',
              storeInfoList: this.goodInfos,
              couponInfoList: this.ticketInfoList,
              shoppingGuideIds: shopArr,
              ...this.reduceResult
            })
              .then(data => {
                this.loading = false
                this.getState()
                this.$message({
                  type: 'success',
                  message: this.$t('deptCollectMoney.operationSuccess'),
                  duration: 2000,
                  showClose: true
                })
              })
              .catch(err => {
                this.loading = false
                this.$message({ type: 'error', message: err, duration: 2000, showClose: true })
              })
          })
          .catch(err => {})
      } else {
        this.hangGetModule = true
      }
    },

    getHangData(data) {
      //取出挂单数据
      if (data) {
        this.isUpdatePrice = false
        this.goodInfos = JSON.parse(JSON.stringify(data.goodInfos))
        let otherList = [] //吊牌代金券、固定搭配促销数据集
        if (data.couponGoodInfos && data.couponGoodInfos.length) {
          this.ticketInfoList = data.couponGoodInfos
          data.couponGoodInfos.forEach(item => {
            if ([1, 2].includes(item.couponType)) {
              let obj = {
                ...item,
                dataType: 'other',
                operationType: '1'
              }
              otherList.push(obj)
            }
          })
        }
        this.tableList = [...(data.goodInfos || []), ...otherList]
        this.reduceResult = data.reduceResult
        this.activeList = data.activityInfos || []
        this.activityInfo = data.checkActivityInfos || []
        this.isAllowNegativeStocks = data.isAllowNegativeStocks
        if (data.brokerage) {
          this.salesTypeId = data.brokerage
          this.curSalesTitle = this.salesList[data.brokerage - 1].title
        }
        if (data.orderTypeId) {
          this.ordingNature = this.ordingTypeList.find(item => {
            return item.id === data.orderTypeId
          })
        }
        if (data.assistantUserIds) {
          this.guiderList = this.shopList.filter(item => {
            return data.assistantUserIds.includes(item.id)
          })
          if (data.brokerage === '1' && this.guiderList.length) {
            this.shopGuide = this.guiderList[0].realName
          }
        }
        if (data.crmVipId) {
          crmVipDetail({ id: data.crmVipId })
            .then(data => {
              this.curVip = data
            })
            .catch(err => {})
        }
        if (this.activeList && this.activeList.length) {
          this.activeList.forEach(act => {
            this.$set(act, 'selectAct', false)
            this.$set(act, 'checkGift', [])
            this.$set(act, 'checkGive', [])
            if (this.activityInfo && this.activityInfo.length) {
              this.activityInfo.forEach(check => {
                if (act.activityId === check.activityId) {
                  act.selectAct = true
                  if (check.giftGoodInfos && check.giftGoodInfos.length) {
                    act.checkGift = check.giftGoodInfos
                  }
                  if (check.addGoodInfos && check.addGoodInfos.length) {
                    act.checkGive = check.addGoodInfos
                  }
                }
              })
            }
          })
        }
      }
    },

    async queryInvoceList() {
      //查询订单性质
      let res = await queryInvoiceType()
      this.ordingTypeList = res || []
      if (res && res.length) {
        this.ordingNature = res[0]
      }
    },

    async queryBrokerageList() {
      //查询业绩方式
      let res = await queryBrokerage({ platform: 'pos' })
      if (res && res[0]) {
        this.salesList = res.map(item => {
          return {
            id: item.code,
            title: item.name
          }
        })
      }
    },

    showGuideList() {
      if (this.openState === 'Y')
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.cannotModifyShopGuide'),
          duration: 2000,
          showClose: true
        })
      this.shopListVisable = true
    },

    saleshande(item) {
      //选择业绩方式
      this.salesVisiable = false
      if (this.salesTypeId === item.id) return
      this.curSalesTitle = item.title
      this.salesTypeId = item.id
      this.guiderList = []
      this.shopGuide = ''
    },

    queryGuide() {
      // 查询营业员
      queryShoppGuide({
        page: '1',
        isSy: 'Y',
        pageSize: '50',
        keyword: this.shopGuide
      })
        .then(res => {
          if (res && res.items) {
            this.shopList = res.items || []
            if (this.openState === 'Y') {
              this.shopList = res.items.filter(item => {
                return item.realName === this.$cache.local.get('deptName')
              })
              this.guiderList = this.shopList
              this.shopGuide = this.guiderList[0].realName
            } else {
              this.shopList = res.items.filter(item => {
                return item.realName !== this.$cache.local.get('deptName')
              })
            }
          }
        })
        .catch(() => {})
    },

    getcurUser(item) {
      //选择营业员
      this.guiderList.splice(0, 1, item)
      this.shopGuide = item.realName
      this.shopListVisable = false
      this.scanInputFocus()
    },

    getGanger(e) {
      //班组营业员
      this.guiderList = []
      this.guideModule = false
      if (e) {
        this.guiderList = e
      }
    },

    guideBlur() {
      //清除选中营业员
      if (!this.shopGuide) {
        this.guiderList = []
      }
    },

    operateItem(barcode, type = '1', operateObj, isScan = 'N', allPrice, priceType) {
      this.scanInputFocus()
      //操作列表货品
      //barcode条码  type操作类型 1货品 2活动 3价格 4次品 6优惠券  operateObj操作对象(货品对象、活动对象、优惠券对象) isScan是否是扫码  allPrice整单改价价格
      let res = this.tableList.some(item => {
        return item.defectiveApplyId
      })
      if (res && (barcode || isScan === 'Y')) {
        this.searchWord = ''
        this.$store.commit('playErrorAudio')
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.onlyAddDefectiveGoods'),
          duration: 2000,
          showClose: true
        })
      }
      if (isScan === 'Y' && !this.searchWord) {
        this.$store.commit('playErrorAudio')
        return this.$message({
          showClose: true,
          type: 'error',
          message: this.$t('deptCollectMoney.scanTagOrInputBarcode'),
          duration: 2000
        })
      }
      if (this.loading) return
      this.loading = true
      let reqData = {
        type: type,
        operationType: this.tabType,
        isUpdatePrice: this.isUpdatePrice ? 'Y' : 'N',
        typeId: this.ordingNature ? this.ordingNature.id : ''
      }
      if (this.alterPriceInfo && this.alterPriceInfo.alterPrice) {
        reqData['isUpdatePrice'] = 'Y'
      }
      if (this.searchWord) {
        reqData['scanSku'] = this.searchWord
      }
      if (barcode) {
        reqData['scanSku'] = barcode
      }
      if (this.isAllowNegativeStocks) {
        reqData['isAllowNegativeStocks'] = this.isAllowNegativeStocks
      }
      if (this.tableList && this.tableList.length) {
        reqData['goodInfos'] = this.goodInfos
      }
      if (operateObj) {
        if (type === '2') {
          reqData['operateActivityInfo'] = operateObj
        } else if (type === '6') {
          reqData['operateCouponsGoodInfo'] = operateObj
        } else {
          reqData['operateGoodInfo'] = operateObj
        }
      }
      if (this.currentCoupon || this.ticketInfoList.length) {
        let index = this.ticketInfoList.findIndex(item => {
          return this.currentCoupon && this.currentCoupon.certificateId === item.certificateId
        })
        if (index !== -1) {
          this.ticketInfoList.splice(index, 1, this.currentCoupon)
          reqData['couponInfoList'] = this.ticketInfoList
        } else {
          if (this.currentCoupon) {
            reqData['couponInfoList'] = [...this.ticketInfoList, ...[this.currentCoupon]]
          } else {
            reqData['couponInfoList'] = this.ticketInfoList
          }
        }
      }
      if (this.activityInfo.length) {
        reqData['checkActivityInfos'] = this.activityInfo
      }
      if (this.activeList.length) {
        reqData['activityInfos'] = this.activeList
      }
      if (allPrice && allPrice.price) {
        reqData['totalOrderAlterPrice'] = allPrice.price
      }
      if (priceType === 'ned') {
        this.isUpdatePrice = false
        reqData['isUpdatePrice'] = 'N'
      }
      if (this.curVip && this.curVip.id) {
        reqData['crmVipId'] = this.curVip.id
      }
      operateGoodsNo(reqData)
        .then(data => {
          if (data && data.alterPriceInfo) {
            this.alterPriceInfo = data.alterPriceInfo
          }
          if (allPrice && data && data.alterPriceInfo) {
            this.alterPriceInfo.reduceResult = data.reduceResult
            this.loading = false
            this.isAllOrding = true
            this.priceModule = true
            return
          }
          if (!data || JSON.stringify(data) === '{}' || (data && !data.goodInfos)) {
            this.$store.commit('playErrorAudio')
            this.$message({
              showClose: true,
              type: 'error',
              message: this.$t('deptCollectMoney.noGoodsInfo'),
              duration: 2000
            })
          } else {
            let otherList = [] //吊牌代金券、固定搭配促销数据集
            if (data.couponGoodInfos && data.couponGoodInfos.length) {
              this.ticketInfoList = data.couponGoodInfos
              data.couponGoodInfos.forEach(item => {
                if ([1, 2].includes(item.couponType)) {
                  let obj = {
                    ...item,
                    dataType: 'other',
                    operationType: '1'
                  }
                  otherList.push(obj)
                }
                if (this.currentCoupon && this.currentCoupon.certificateId === item.certificateId) {
                  this.currentCoupon = item
                }
              })
            } else {
              this.ticketInfoList = []
              this.currentCoupon = null
            }
            this.goodInfos = JSON.parse(JSON.stringify(data.goodInfos))
            this.tableList = [...(data.goodInfos || []), ...otherList]
            GridManager.refreshGrid(this.gridOption.gridManagerName)
            this.reduceResult = data.reduceResult
            this.activeList = data.activityInfos || []
            this.activityInfo = data.checkActivityInfos || []
            this.isAllowNegativeStocks = data.isAllowNegativeStocks
            if (this.activeList && this.activeList.length) {
              this.activeList.forEach(act => {
                this.$set(act, 'selectAct', false)
                this.$set(act, 'checkGift', [])
                this.$set(act, 'checkGive', [])
                if (this.activityInfo && this.activityInfo.length) {
                  this.activityInfo.forEach(check => {
                    if (act.activityId === check.activityId) {
                      act.selectAct = true
                      if (check.giftGoodInfos && check.giftGoodInfos.length) {
                        act.checkGift = check.giftGoodInfos
                      }
                      if (check.addGoodInfos && check.addGoodInfos.length) {
                        act.checkGive = check.addGoodInfos
                      }
                    }
                  })
                }
              })
            }
            if (isScan === 'Y' || barcode) {
              this.$store.commit('playSuccessAudio')
            }
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('deptCollectMoney.operationSuccess'),
              duration: 2000
            })
          }
          if (this.tableList[0]) {
            GridManager.renderGrid(this.gridOption.gridManagerName)
          }
          this.searchWord = ''
          this.loading = false
        })
        .catch(error => {
          this.searchWord = ''
          this.$store.commit('playErrorAudio')
          GridManager.renderGrid(this.gridOption.gridManagerName)
          if (this.activeList && this.activeList.length) {
            this.activeList.forEach(act => {
              this.$set(act, 'selectAct', false)
              this.$set(act, 'checkGift', [])
              this.$set(act, 'checkGive', [])
              if (this.activityInfo && this.activityInfo.length) {
                this.activityInfo.forEach(check => {
                  if (act.activityId === check.activityId) {
                    act.selectAct = true
                    if (check.giftGoodInfos && check.giftGoodInfos.length) {
                      act.checkGift = check.giftGoodInfos
                    }
                    if (check.addGoodInfos && check.addGoodInfos.length) {
                      act.checkGive = check.addGoodInfos
                    }
                  }
                })
              }
            })
          }
          this.loading = false
          this.$message({ showClose: true, type: 'error', message: error, duration: 2000 })
        })
    },

    showTable() {
      if (this.tableList.length) {
        let goodsNed = this.tableList.map(item => {
          return item.operationType
        })
        if (goodsNed.includes('6')) {
          GridManager.showTh(this.gridOption.gridManagerName, ['agoRealPrice'])
        } else {
          GridManager.hideTh(this.gridOption.gridManagerName, ['agoRealPrice'])
        }
      }

      // 渲染表格数据
      return new Promise((resolve, reject) => {
        const tableData = {
          data: this.tableList
        }
        resolve(tableData)
      })
    },

    checkValue(row, type) {
      //货品列表输入框的值验证
      if (type === 'price') {
        row.realPrice = row.realPrice
          .replace(/[^\d^\.]+/g, '')
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.')
        row.realPrice = row.realPrice.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
      } else {
        row.number = row.number.replace(/\D|^0/g, '')
      }
    },
    cellTip(row) {
      if (row.defectiveApplyId || row.operationType === '2' || row.isExchange === 'Y')
        this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.cannotModifyDefectiveGiftGoods'),
          duration: 2000,
          showClose: true
        })
    },
    minusHandel(row, index) {
      //数量减少
      if (row.defectiveApplyId || row.operationType === '2' || row.isExchange === 'Y') {
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.cannotModifyDefectiveGiftGoods'),
          duration: 2000,
          showClose: true
        })
      }
      let obj = {
        index: index,
        barCode: row.barCode,
        sku: row.sku,
        number: '-1',
        isRedemption: row.isRedemption || 'N',
        operationType: row.operationType,
        alterGoodsWay: '2'
      }
      if (row.activityId) {
        obj['activityId'] = row.activityId
      }
      if (row.alterRealPrice) {
        obj['alterRealPrice'] = row.alterRealPrice
      }
      if (row.hasAlterPriceReview === 'Y') {
        obj['hasAlterPriceReview'] = row.hasAlterPriceReview
      }
      if (row.giftRuleId) {
        obj['giftRuleId'] = row.giftRuleId
      }
      if (row.giftRuleDetailId) {
        obj['giftRuleDetailId'] = row.giftRuleDetailId
      }
      this.alterPriceInfo = {}
      this.goodInfos.forEach((item, index) => {
        if (item.hasAlterPriceReview == 'Y') {
          if (item.retailPrice) {
            this.$set(this.goodInfos[index], 'realPrice', item.retailPrice)
            this.$set(this.goodInfos[index], 'hasAlterPriceReview', 'N')
          }
        }
      })
      this.operateItem('', '1', obj)
    },

    plusHandel(row, index) {
      //数量增加
      if (row.defectiveApplyId || row.operationType === '2' || row.isExchange === 'Y') {
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.cannotModifyDefectiveGiftGoods'),
          duration: 2000,
          showClose: true
        })
      }
      let obj = {
        index: index,
        barCode: row.barCode,
        sku: row.sku,
        number: '1',
        isRedemption: row.isRedemption || 'N',
        operationType: row.operationType,
        alterGoodsWay: '1'
      }
      if (row.activityId) {
        obj['activityId'] = row.activityId
      }
      if (row.alterRealPrice) {
        obj['alterRealPrice'] = row.alterRealPrice
      }
      if (row.hasAlterPriceReview === 'Y') {
        obj['hasAlterPriceReview'] = row.hasAlterPriceReview
      }
      if (row.giftRuleId) {
        obj['giftRuleId'] = row.giftRuleId
      }
      if (row.giftRuleDetailId) {
        obj['giftRuleDetailId'] = row.giftRuleDetailId
      }
      this.alterPriceInfo = {}
      this.goodInfos.forEach((item, index) => {
        if (item.hasAlterPriceReview == 'Y') {
          if (item.retailPrice) {
            this.$set(this.goodInfos[index], 'realPrice', item.retailPrice)
            this.$set(this.goodInfos[index], 'hasAlterPriceReview', 'N')
          }
        }
      })
      this.operateItem('', '1', obj)
    },

    blurHandel(row, index) {
      //输入数量
      if (Number(this.rowValurInit) === Number(row.number)) return
      if (!row.number || +row.number <= 0) {
        GridManager.renderGrid(this.gridOption.gridManagerName)
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.inputValidQuantity'),
          duration: 2000,
          showClose: true
        })
      }
      let obj = {
        index: index,
        barCode: row.barCode,
        sku: row.sku,
        number: row.number,
        isRedemption: row.isRedemption || 'N',
        operationType: row.operationType,
        alterGoodsWay: '3'
      }
      if (row.activityId) {
        obj['activityId'] = row.activityId
      }
      if (row.alterRealPrice) {
        obj['alterRealPrice'] = row.alterRealPrice
      }
      if (row.hasAlterPriceReview === 'Y') {
        obj['hasAlterPriceReview'] = row.hasAlterPriceReview
      }
      if (row.giftRuleId) {
        obj['giftRuleId'] = row.giftRuleId
      }
      if (row.giftRuleDetailId) {
        obj['giftRuleDetailId'] = row.giftRuleDetailId
      }
      this.alterPriceInfo = {}
      this.goodInfos.forEach((item, index) => {
        if (item.hasAlterPriceReview == 'Y') {
          if (item.retailPrice) {
            this.$set(this.goodInfos[index], 'realPrice', item.retailPrice)
            this.$set(this.goodInfos[index], 'hasAlterPriceReview', 'N')
          }
        }
      })
      this.operateItem('', '1', obj)
    },

    recoverPriceMount(row, index, type) {
      this.$confirm(this.$t('deptCollectMoney.confirmCancelPriceChange'), this.$t('deptCollectMoney.tip'))
        .then(res => {
          this.getnewRow(row, index, type)
        })
        .catch(() => {})
    },
    getDefault(value) {
      this.rowValurInit = value
    },
    getnewRow(row, index, type) {
      // 修改当前行的实卖价
      if (type !== 'recoverNed' && Number(this.rowValurInit) === Number(row.realPrice)) return
      if (row.defectiveApplyId && Number(row.realPrice) <= 0) {
        GridManager.renderGrid(this.gridOption.gridManagerName)
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.inputAmountGreaterThanZero'),
          duration: 2000,
          showClose: true
        })
      }
      if (!row.realPrice) {
        GridManager.renderGrid(this.gridOption.gridManagerName)
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.inputValidAmount'),
          duration: 2000,
          showClose: true
        })
      }
      if (this.activityInfo && this.activityInfo.length) {
        GridManager.renderGrid(this.gridOption.gridManagerName)
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.promotionCannotChangePrice'),
          duration: 2000,
          showClose: true
        })
      }
      let obj = {
        index: index,
        barCode: row.barCode,
        sku: row.sku,
        number: row.number,
        isRedemption: row.isRedemption || 'N',
        operationType: '5',
        price: row.realPrice,
        alterGoodsWay: '3'
      }

      if (row.activityId) {
        obj['activityId'] = row.activityId
      }
      if (row.alterRealPrice) {
        obj['alterRealPrice'] = row.alterRealPrice
      }
      if (row.hasAlterPriceReview === 'Y') {
        obj['hasAlterPriceReview'] = row.hasAlterPriceReview
      }
      if (type == 'recoverNed') {
        obj['price'] = row.retailPrice
        obj['hasAlterPriceReview'] = 'N'
        this.alterPriceInfo = {}
        this.goodInfos.forEach((item, index) => {
          if (item.hasAlterPriceReview == 'Y') {
            if (item.retailPrice) {
              this.$set(this.goodInfos[index], 'realPrice', item.retailPrice)
              this.$set(this.goodInfos[index], 'hasAlterPriceReview', 'N')
            }
          }
        })
      }
      let list = []
      this.goodInfos.filter((item, idx) => {
        if (item.operationType !== '6' && idx !== index) {
          list.push(item)
        }
      })
      let recoverPrice = true
      if (list && list.length) {
        recoverPrice = list.every(item => {
          return Number(item.realPrice) === Number(item.initRealPrice)
        })
      }
      if (type == 'recoverNed') {
        this.isUpdatePrice = !recoverPrice
        this.$set(this.goodInfos[index], 'hasAlterPriceReview', 'N')
        this.alterPriceInfo = {}
        obj['alterGoodsWay'] = '5'
        this.operateItem('', '1', obj)
      } else {
        if (Number(row.realPrice) === Number(row.agoRealPrice) && recoverPrice) {
          this.isUpdatePrice = false
          this.alterPriceInfo = {}
          obj['alterGoodsWay'] = '5'
          this.operateItem('', '1', obj)
        } else {
          this.isUpdatePrice = true
          this.$set(this.goodInfos[index], 'hasAlterPriceReview', 'Y')
          this.operateItem('', '3', obj)
        }
      }
    },

    cancelUpdatePrice() {
      if (this.isAllOrding) {
        this.alterPriceInfo = {}
        this.isUpdatePrice = false
      }
      this.priceModule = false
      this.isAllOrding = false
      this.scanInputFocus()
    },

    guigeHandel(row, index) {
      // 选择规格弹窗
      if (row.defectiveApplyId || row.operationType === '2' || row.isExchange === 'Y') {
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.cannotModifyDefectiveGiftGoods'),
          duration: 2000,
          showClose: true
        })
      }
      this.curRow = row
      this.guigeModule = true
      this.tableIndex = index
    },

    closeGuigeModul(row) {
      // 关闭选择规格
      this.guigeModule = false
      if (row) {
        let obj = {
          index: this.tableIndex,
          barCode: row.barCode,
          sku: row.sku,
          number: row.number,
          isRedemption: row.isRedemption || 'N',
          operationType: this.curRow.operationType,
          alterGoodsWay: '5'
        }
        if (this.curRow.activityId) {
          obj['activityId'] = this.curRow.activityId
        }
        if (row.alterRealPrice) {
          obj['alterRealPrice'] = row.alterRealPrice
        }
        if (row.hasAlterPriceReview === 'Y') {
          obj['hasAlterPriceReview'] = row.hasAlterPriceReview
        }
        if (row.giftRuleId) {
          obj['giftRuleId'] = row.giftRuleId
        }
        if (row.giftRuleDetailId) {
          obj['giftRuleDetailId'] = row.giftRuleDetailId
        }

        this.operateItem('', '1', obj)
      }
      this.scanInputFocus()
    },
    //关闭库存账卡
    closeStockAccountCard() {
      this.stockAccountCardModule = false
      this.scanInputFocus()
    },
    delRow(row, index) {
      //删除表格中一条记录
      this.$confirm(this.$t('deptCollectMoney.confirmDeleteRecord'), this.$t('deptCollectMoney.tip'))
        .then(() => {
          let obj = {
            index: index,
            barCode: row.barCode,
            sku: row.sku,
            number: row.number * -1,
            isRedemption: row.isRedemption || 'N',
            operationType: row.operationType,
            alterGoodsWay: '4'
          }
          if (row.defectiveApplyId) {
            obj['defectiveId'] = row.defectiveApplyId
          }
          if (row.activityId) {
            obj['activityId'] = row.activityId
          }
          this.alterPriceInfo = {}
          this.goodInfos.forEach((item, index) => {
            if (item.hasAlterPriceReview == 'Y') {
              if (item.retailPrice) {
                this.$set(this.goodInfos[index], 'realPrice', item.retailPrice)
                this.$set(this.goodInfos[index], 'hasAlterPriceReview', 'N')
              }
            }
          })
          this.operateItem('', row.defectiveApplyId ? '4' : '1', obj)
        })
        .catch(() => {})
    },

    backOutTicket(row) {
      this.$confirm(
        this.$t('deptCollectMoney.confirmCancelVerification'),
        this.$t('deptCollectMoney.cancelVerificationTip')
      )
        .then(res => {
          let obj = {
            operationCouponType: '5',
            certificateId: row.certificateId
          }
          this.operateItem('', '6', obj)
        })
        .catch(err => {})
    },

    clearAll() {
      // 清空表格数据
      this.scanInputFocus()
      if (!this.tableList.length) return
      if (this.ticketInfoList.length) {
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.clearAfterCancelTicket'),
          duration: 2000,
          showClose: true
        })
      }
      this.$confirm(this.$t('deptCollectMoney.confirmClearGoodsList'), this.$t('deptCollectMoney.dialogTip'))
        .then(() => {
          this.tableList = []
          this.reduceResult = {}
          this.activeList = []
          this.goodInfos = []
          this.alterPriceInfo = {}
          this.$message({
            type: 'success',
            message: this.$t('deptCollectMoney.operationSuccess'),
            duration: 2000,
            showClose: true
          })
        })
        .catch(() => {})
    },

    rightClickRow(cell) {
      // 表格右键方法获取当前行数据
      let tr = cell.parentNode
      let row = GridManager.getRowData(this.gridOption.gridManagerName, tr)
      while (!row['barCode']) {
        tr = tr.parentNode
        row = GridManager.getRowData(this.gridOption.gridManagerName, tr)
      }
      return row
    },

    rightDelete(g, cell) {
      // 右键删除
      let row = this.rightClickRow(cell)
      if (row.dataType === 'other') return
      let index = this.goodInfos.findIndex(item => {
        return (
          item.barCode === row.barCode &&
          item.realPrice === row.realPrice &&
          row.activityId === item.activityId &&
          row.operationType === item.operationType
        )
      })
      this.delRow(row, index)
    },

    getskuData(e) {
      //单款库存和次品弹窗加到货品列表
      if (e) {
        if (e.id && e.badGoods) {
          let obj = {
            alterGoodsWay: '1',
            defectiveId: e.id
          }
          this.operateItem('', '4', obj)
        } else {
          this.operateItem(e)
        }
      }
    },

    chooseActive(item) {
      //选择活动
      if (item.isOptional === 'N') {
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.promotionConflictWithTicket'),
          duration: 2000,
          showClose: true
        })
      }
      item.selectAct = !item.selectAct
      if (item.selectAct) {
        let checkMutIds = []
        if (this.activityInfo && this.activityInfo.length) {
          this.activityInfo.forEach(check => {
            if (check.mutualExclusionActivityIds && check.mutualExclusionActivityIds.length) {
              checkMutIds = checkMutIds.concat(check.mutualExclusionActivityIds)
            }
          })
        }
        if (checkMutIds.includes(item.activityId)) {
          item.selectAct = false
          return this.$message({
            type: 'error',
            message: this.$t('deptCollectMoney.activityMutualExclusion'),
            duration: 2000,
            showClose: true
          })
        }
        let obj = {
          operateType: 'Y',
          activityId: item.activityId
        }
        this.operateItem('', '2', obj)
      } else {
        let obj = {
          operateType: 'N',
          activityId: item.activityId
        }
        this.operateItem('', '2', obj)
      }
    },

    giftAdd(type, item) {
      if (!item.selectAct)
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.selectActivityFirst'),
          duration: 2000,
          showClose: true
        })
      this.currentActive = item
      let checkMutIds = []
      if (this.activityInfo && this.activityInfo.length) {
        this.activityInfo.forEach(check => {
          if (check.mutualExclusionActivityIds && check.mutualExclusionActivityIds.length) {
            checkMutIds = checkMutIds.concat(check.mutualExclusionActivityIds)
          }
        })
      }
      if (checkMutIds.includes(item.activityId)) {
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.activityMutualExclusion'),
          duration: 2000,
          showClose: true
        })
      }
      if (type === 'gift') {
        this.giveModele = true
      } else {
        this.tradeModule = true
      }
    },
    showActGoods(item) {
      const goodsList = this.tableList.filter(good => {
        return good.activityId === item.activityId
      })
      const list = goodsList.map(item => {
        return {
          spu: item.spu,
          sku: item.sku,
          attr: item.attr,
          number: item.number,
          goodsName: item.goodsName,
          imageList: item.imageList || [],
          isAddBuy: item.isExchange === 'Y',
          isGift: item.operationType === '2'
        }
      })
      this.currentActive = {
        list: list,
        activityName: item.activityName
      }
      this.activeModule = true
    },

    clsoePliment(e) {
      //关闭选择赠品弹窗
      this.giveModele = false
      if (e) {
        let obj = {
          activityId: e.activityId,
          giftOrAddType: 'Y'
        }
        if (e.checkGift && e.checkGift.length) {
          obj['giftGoodInfos'] = e.checkGift
        }
        this.operateItem('', '2', obj)
      }
      this.scanInputFocus()
    },

    closeTrade(e) {
      //关闭加购货品弹窗
      this.tradeModule = false
      if (e) {
        let obj = {
          activityId: e.activityId,
          giftOrAddType: 'N'
        }
        if (e.checkGive && e.checkGive.length) {
          obj['addGoodInfos'] = e.checkGive
        }
        this.operateItem('', '2', obj)
      }
      this.scanInputFocus()
    },

    changePriceModule() {
      // 整单改价弹窗
      if (!this.tableList.length)
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.addGoodsFirst'),
          duration: 2000,
          showClose: true
        })
      let res = this.tableList.some(item => {
        return item.defectiveApplyId
      })
      if (res) {
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.defectiveCannotChangePrice'),
          duration: 2000,
          showClose: true
        })
      }
      this.allPriceModule = true
    },

    changeAllPrice(e) {
      //整单改价
      this.allPriceModule = false
      if (e) {
        this.isUpdatePrice = true
        this.operateItem('', '3', '', 'N', e)
      }
      this.scanInputFocus()
    },

    checkPublicState(type) {
      this.isQuicklyPay = type
      if (Number(this.reduceResult.receivablePrice) < 0) {
        return this.$message.error(this.$t('deptCollectMoney.exchangeNoRefund'))
      }
      let subList = this.tableList.map(item => {
        return item.operationType
      })
      if (subList.length && subList.includes('6') && !subList.includes('1')) {
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.addExchangeGoodsFirst'),
          duration: 2000,
          showClose: true
        })
      }
      if (this.openState === 'Y') {
        queryPublicOrderEnableState({
          page: '1',
          pageSizes: '1',
          marketIdList: [this.$cache.local.get('marketingUnitId')]
        })
          .then(res => {
            if (res && res.items && res.items[0].stateCode === '0') {
              this.$confirm(this.$t('deptCollectMoney.publicOrderClosedTip'), this.$t('deptCollectMoney.tip'), {
                showClose: false,
                showCancelButton: false,
                closeOnClickModal: false,
                closeOnPressEscape: false
              })
                .then(() => {
                  this.openState = 'N'
                  this.shopGuide = ''
                  this.guiderList = []
                  this.queryGuide()
                })
                .catch(() => {})
            } else {
              this.accountHandel()
            }
          })
          .catch(error => {})
      } else {
        this.accountHandel()
      }
    },
    effectStateClose() {
      this.effectStateDialog = false
    },
    accountHandel() {
      this.isDown = false
      if (this.curVip && this.curVip.effectState == '1') {
        return (this.effectStateDialog = true)
      }
      if (!this.tableList.length)
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.addGoodsFirst'),
          duration: 2000,
          showClose: true
        })
      if (!this.guiderList.length || !this.shopList.length) {
        if (this.salesTypeId === '1') {
          this.$nextTick(() => {
            this.$refs.focusGuider.focus()
          })
        } else {
          this.guideModule = true
        }
        return this.$message({
          type: 'error',
          message: this.$t('deptCollectMoney.chooseShopGuide'),
          duration: 2000,
          showClose: true
        })
      }
      const list = this.tableList.filter(item => {
        return item.hasAlterPriceReview === 'Y' && !item.defectiveApplyId
      })
      let changGoodsNo = list.map(item => {
        return item.goodsNo
      })
      if (changGoodsNo && changGoodsNo[0]) {
        this.$confirm(
          `${this.$t('deptCollectMoney.priceChangeOverLimit')}${changGoodsNo}`,
          this.$t('deptCollectMoney.priceChangeLimitTitle'),
          {
            closeOnClickModal: false
          }
        )
          .then(() => {
            this.priceModule = true
          })
          .catch(error => {})
      } else {
        if (Number(this.reduceResult.receivablePrice) < 0) {
          return this.$message.error(this.$t('deptCollectMoney.exchangeNoRefund'))
        } else if (Number(this.reduceResult.receivablePrice) == 0) {
          this.payLose()
        } else {
          if (this.isQuicklyPay === 'quickly') {
            this.payQuickly()
          } else {
            this.payTypeDialog = true
          }
        }
      }
    },

    payQuickly() {
      if (this.quicklyLoading) return
      this.quicklyLoading = true
      let shopArr = this.guiderList.map(item => {
        return item.id
      })
      submitStoreInvoice({
        storeInfoList: this.goodInfos,
        couponInfoList: this.ticketInfoList,
        type: '2',
        source: '2',
        terminalId: this.cashierItem ? this.cashierItem.id : '',
        orderTypeId: this.ordingNature.id,
        brokerage: this.salesTypeId,
        crmVipId: this.curVip ? this.curVip.id : '',
        isAlterpriceReview: this.isUpdatePrice ? 'Y' : 'N',
        checkActivityInfos: this.activityInfo,
        shoppingGuideIds: shopArr,
        ...this.reduceResult,
        proceedsInfoList: [
          {
            id: this.quicklyPay.id,
            proceedsPrice: this.reduceResult.receivablePrice
          }
        ]
      })
        .then(data => {
          this.getState()
          this.scanWaiting = true
          this.quicklyOrder = data
          this.quicklyLoading = false
        })
        .catch(error => {
          this.quicklyLoading = false
          this.$message({ type: 'error', message: error, duration: 2000, showClose: true })
        })
    },
    closeScan() {
      this.quicklyOrder = null
      this.scanWaiting = false
      this.quicklyLoading = false
      this.scanInputFocus()
    },

    payLose() {
      //金额为负时直接支付
      if (this.payLoading) return
      this.loading = true
      this.payLoading = true
      let shopArr = this.guiderList.map(item => {
        return item.id
      })
      submitStoreInvoice({
        storeInfoList: this.goodInfos,
        couponInfoList: this.ticketInfoList,
        type: '2',
        source: '2',
        terminalId: this.cashierItem ? this.cashierItem.id : '',
        orderTypeId: this.ordingNature.id,
        brokerage: this.salesTypeId,
        crmVipId: this.curVip ? this.curVip.id : '',
        isAlterpriceReview: this.isUpdatePrice ? 'Y' : 'N',
        checkActivityInfos: this.activityInfo,
        shoppingGuideIds: shopArr,
        ...this.reduceResult,
        //为0直接支付，必现金支付且必为0
        proceedsInfoList: [
          {
            id: '1',
            proceedsPrice: '0'
          }
        ]
      })
        .then(data => {
          this.getState()
          this.queryPrintData(data.innerSn)
          this.payLoading = false
          this.$message({
            type: 'success',
            message: this.$t('deptCollectMoney.settlementCompleted'),
            duration: 2000,
            showClose: true
          })
          this.loading = false
        })
        .catch(err => {
          this.payLoading = false
          this.loading = false
          this.$message({ type: 'error', message: err, duration: 2000, showClose: true })
        })
      // .then(data => {
      //   generatePayInfo({
      //     id: data.id,
      //     isAlteration: 'Y',
      //     proceedsInfoList: [{ id: '1', proceedsPrice: this.reduceResult.receivablePrice }],
      //     terminalId: this.cashierItem ? this.cashierItem.id : ''
      //   })
      //     .then(res => {
      //       this.getState()
      //       this.queryPrintData(data.innerSn)
      //       this.payLoading = false
      //       this.$message({ type: 'success', message: '结算完成！', duration: 2000, showClose: true })
      //       this.loading = false
      //     })
      //     .catch(err => {
      //       this.payLoading = false
      //       this.loading = false
      //       this.$message({ type: 'error', message: err, duration: 2000, showClose: true })
      //     })
      // })
      // .catch(error => {
      //   this.payLoading = false
      //   this.loading = false
      //   this.$message({ type: 'error', message: error, duration: 2000, showClose: true })
      // })
    },

    queryPrintData(invoicesNo) {
      // this.DoReceiptsModal = true
      // if(type === 'scanPay'){
      //   this.$store.commit('playPayScanTip')
      // }
      // this.$store.commit('playPayScanTip')
      this.$message({
        type: 'success',
        message: this.$t('deptCollectMoney.paySuccessText'),
        duration: 2000,
        showClose: true
      })
      let printer = this.$cache.local.get('printerModel')
      let printCount = this.$cache.local.get('retailReceiptCount')
      let printCode = this.$cache.local.get('retailReceiptCode')
      let params = {
        sn: invoicesNo
      }
      this.webViewUrl = `${
        request.printPreviewRoot
      }?printerName=${printer}&templateCode=${printCode}&printCount=0&data=${encodeURI(JSON.stringify(params))}`
      let eggRootUrl = `${request.printEggPreviewRoot}?printerName=${printer}&templateCode=${printCode}&`
      const eggSrc =
        eggRootUrl + `printCount=${printCount}&data=${encodeURI(JSON.stringify(params))}&sn=${params['sn']}`
      ipc.invoke(ipcApiRoute.print, { contentUrl: eggSrc, sn: params['sn'] }).then(r => {})
      if (this.scanWaiting) {
        this.scanWaiting = false
      }
      this.scanInputFocus()
    },
    closePayDialog() {
      this.payTypeDialog = false
      this.scanInputFocus()
    },
    getState() {
      //订单生成成功回调重置首页一些数据
      this.tableList = []
      this.goodInfos = []
      this.activeList = []
      this.activityInfo = []
      this.alterPriceInfo = {}
      if (this.openState === 'N') {
        this.shopGuide = ''
        this.guiderList = []
      }
      this.reduceResult = {}
      this.curVip = null
      this.ticketInfoList = []
      this.currentCoupon = null
    },
    reChooseMember() {
      let hasPinker = this.ticketInfoList.some(item => {
        return item.channel === '3'
      })
      if (hasPinker) {
        return this.$message({
          showClose: true,
          type: 'error',
          message: this.$t('deptCollectMoney.clearPinkerTicketFirst'),
          duration: 2000
        })
      }
      this.curVip = null
      if (this.tableList.length) {
        this.operateItem('')
      }
    },
    getVipMobile(e) {
      if (!this.curVip) {
        this.memberValue = e
        this.queryBuyMember()
      }
    },
    queryBuyMember() {
      let printInfo = this.memberValue.trim()
      if (!printInfo) {
        this.memberValue = ''
        return
      }
      printQueryVipInfo({
        printInfo: printInfo
      })
        .then(res => {
          this.memberValue = ''
          if (res) {
            this.curVip = res[0]
            this.scanInputFocus()
          }
        })
        .catch(error => {
          this.memberValue = ''
          this.$nextTick(() => {
            this.$refs.memberInput.focus()
          })
          this.$message({ type: 'error', message: error, duration: 2000, showClose: true })
        })
    },
    changeState() {
      if (this.openState === 'N') {
        openPublicOrderValid()
          .then(res => {
            this.shopGuide = ''
            this.guiderList = []
            this.settingPublic = true
          })
          .catch(error => {
            this.$message({ type: 'error', message: error, duration: 2000, showClose: true })
          })
      }
      if (this.openState === 'Y') {
        this.scanInputFocus()
        this.$confirm(this.$t('deptCollectMoney.confirmClosePublicOrder'), this.$t('deptCollectMoney.tip'))
          .then(res => {
            closePublicOrder()
              .then(res => {
                this.openState = 'N'
                this.shopGuide = ''
                this.guiderList = []
                this.queryGuide()
                this.$message({
                  type: 'success',
                  message: this.$t('deptCollectMoney.publicOrderClosed'),
                  duration: 2000,
                  showClose: true
                })
              })
              .catch(error => {
                this.$message({ type: 'error', message: error, duration: 2000, showClose: true })
              })
          })
          .catch(() => {})
      }
    },
    cancelOpen() {
      closePublicOrder()
        .then(res => {
          this.openState = 'N'
          this.shopGuide = ''
          this.guiderList = []
        })
        .catch(error => {
          this.$message({ type: 'error', message: error, duration: 2000, showClose: true })
        })
    },
    sureOpen(e) {
      this.queryGuide()
      this.joinUser = e
      this.openState = 'Y'
      this.settingPublic = false
      this.scanInputFocus()
    },

    openTicketHandel() {
      let res = this.tableList.some(item => {
        return item.defectiveApplyId
      })
      if (res) {
        return this.$message({
          showClose: true,
          type: 'error',
          message: this.$t('deptCollectMoney.defectiveCannotVerifyTicket'),
          duration: 2000
        })
      }
      this.openTicket = true
    },
    changeCheckType(data) {
      this.checkObject = data
      this.openTicket = true
      this.showTicketGoods = false
    },
    reChoose(row) {
      this.currentCoupon = row
      this.ticketLogType = 'choose'
      this.ticketGoodsOpen = true
    },
    ticketGoodsClose(e) {
      this.currentCoupon = null
      this.ticketGoodsOpen = false
      if (e) {
        if (e === 'recheck') {
          this.openTicket = true
        } else {
          this.updateInfo(e)
        }
        if (this.openTicket && e !== 'recheck') {
          this.openTicket = false
          this.checkObject = null
        }
      }
    },
    updateInfo(e) {
      let otherList = []
      if (e.couponGoodInfos && e.couponGoodInfos.length) {
        e.couponGoodInfos.forEach(item => {
          if ([1, 2].includes(item.couponType)) {
            let obj = {
              ...item,
              dataType: 'other',
              operationType: '1'
            }
            otherList.push(obj)
          }
        })
      }
      this.tableList = [...(e.goodInfos || []), ...otherList]
      this.reduceResult = e.reduceResult
      this.ticketInfoList = e.couponGoodInfos
      if (!this.ticketInfoList.length && this.currentCoupon) {
        this.currentCoupon = null
      }
      this.goodInfos = JSON.parse(JSON.stringify(e.goodInfos))
      GridManager.refreshGrid(this.gridOption.gridManagerName)
      // 处理促销
      if (e.activityInfos && e.activityInfos.length) {
        this.activeList = e.activityInfos || []
        this.activityInfo = e.checkActivityInfos || []
        this.activeList.forEach(act => {
          this.$set(act, 'selectAct', false)
          this.$set(act, 'checkGift', [])
          this.$set(act, 'checkGive', [])
          if (this.activityInfo.length) {
            this.activityInfo.forEach(check => {
              if (act.activityId === check.activityId) {
                act.selectAct = true
                if (check.giftGoodInfos && check.giftGoodInfos.length) {
                  act.checkGift = check.giftGoodInfos
                }
                if (check.addGoodInfos && check.addGoodInfos.length) {
                  act.checkGive = check.addGoodInfos
                }
              }
            })
          }
        })
      }
    },
    openGiveCheck(item, data) {
      if ([1, 2].includes(item.couponType)) {
        //吊牌价、固定货品组合券类型
        this.currentCoupon = item
        if (data === 'chooseType') {
          this.ticketLogType = 'changeType'
        } else {
          this.ticketLogType = 'check'
        }
        this.ticketGoodsOpen = true
      } else {
        //实卖价抵扣、现金券确认核销
        this.updateInfo(data)
        if (item.isHaveGift === 'Y') {
          this.currentCoupon = item
          this.giveVisible = true
        }
      }
    },
    operateList(e) {
      //实卖价抵扣现金券 确认赠品
      this.currentCoupon = e
      let obj = {
        operationCouponType: '4',
        certificateId: e.certificateId
      }
      this.operateItem('', '6', obj)
    }
  }
}
</script>

<style lang="scss" scoped>
.content-main {
  width: calc(100vw - 430px);
  margin: 0 10px 10px;
  .main-info {
    margin-top: 10px;
    background: #ffffff;
    height: calc(100vh - 160px);
    width: calc(100vw - 430px);
    padding: 10px;
  }

  .bottom-tools {
    height: 80px;
    font-size: 14px;
    background: #fff;
    .ticket-div {
      color: #fff;
      cursor: pointer;
      font-size: 12px;
      margin-left: 10px;
      padding: 5px 10px;
      font-weight: bold;
      text-align: center;
      border-radius: 8px;
      background: #722ed1;
      p {
        margin: 5px 0;
      }
      span {
        color: #ddd;
        font-weight: normal;
      }
    }
    .divider {
      width: 2px;
      height: 40px;
      margin: 0 10px;
      background: #bbbbbb;
    }
    .active-label {
      width: 20px;
      color: #fff;
      font-size: 12px;
      padding: 3px 0;
      line-height: 12px;
      font-weight: bold;
      text-align: center;
      border-radius: 4px;
      background: #077cf2;
      i {
        font-weight: bold;
      }
    }
    .active-list {
      max-width: 1180px;
      overflow: auto;
      padding-left: 20px;
      .active-item {
        height: 68px;
        width: 300px;
        flex-shrink: 0;
        cursor: pointer;
        font-size: 12px;
        background: #eee;
        margin-right: 20px;
        border-radius: 8px;
        position: relative;
        border: 1px solid #f9f9f9;
        .gift-add {
          top: 2px;
          width: 100%;
          position: absolute;
          .active-type {
            color: #067cf2;
            padding: 1px 5px;
            margin-left: 20px;
            border-radius: 4px;
            text-align: center;
            background: #deeef9;
          }
          .gift {
            color: rgb(250, 140, 22);
          }
          .add {
            color: rgb(114, 46, 209);
          }
        }
        .active-title {
          color: #000;
          font-size: 15px;
          overflow: hidden;
          font-weight: bold;
          white-space: nowrap;
          margin: 0 0 0 20px;
          text-overflow: ellipsis;
        }
        .active-flag {
          top: 20px;
          left: -13px;
          width: 26px;
          height: 26px;
          background: #ddd;
          border-radius: 4px;
          position: absolute;
          i {
            color: #fff;
          }
        }
        .show-goods {
          right: 5px;
          color: #999;
          bottom: 3px;
          font-size: 12px;
          cursor: pointer;
          position: absolute;
          margin-top: 30px;
        }
      }
      .select-item {
        background: #fff;
        border-color: #067cf2;
        .active-flag {
          background: #067cf2;
        }
      }
    }
    .active-5 {
      max-width: 1400px;
    }
    .action-btn {
      color: #fff;
      width: 90px;
      cursor: pointer;
      font-size: 18px;
      line-height: 40px;
      border-radius: 4px;
      text-align: center;
      margin-right: 10px;
      background: #f8475f;
      box-shadow: 5px 5px 10px 0 rgba(248, 71, 95, 0.38);
    }
  }
}

.content-aside {
  flex: 1;
  margin-top: 10px;
  margin-right: 10px;
  overflow: hidden;
  position: relative;
  .tab-type {
    width: 380px;
    cursor: pointer;
    background: #fff;
    padding: 5px 10px;
    border-radius: 4px;
    box-shadow: 0 2px 10px 0 rgba(6, 124, 242, 0.21);
    div {
      padding: 5px 0;
      background: #fff;
      text-align: center;
      border-radius: 4px;
      width: calc(100% / 2);
    }
  }

  .aside-scan {
    box-shadow: 0px 2px 10px 0px rgba(6, 124, 242, 0.21);
    background: #fff;
    border-radius: 4px;
    color: #c56209;
    margin-right: 10px;
    height: 50px;
    border: 2px solid #fff;
    i {
      font-size: 30px;
      margin: 0 10px;
    }
    span {
      width: 1px;
      height: 20px;
      background: #c56209;
      margin-right: 10px;
    }
    input {
      background: none;
      outline: none;
      font-size: 14px;
      color: #067cf2;
      width: 100%;
      margin-right: 10px;
      line-height: 48px;
      border: none;
      font-family: 'font-Medium';
    }
    input::-webkit-input-placeholder {
      color: #067cf2;
    }
    input:focus {
      color: #c56209;
    }
    input:focus::-webkit-input-placeholder {
      color: #c56209;
    }
  }

  .scan-tip {
    width: 100%;
    margin-right: 10px;
    margin-top: 10px;
    background: #fff;
    box-shadow: 0px 2px 10px 0px rgba(6, 124, 242, 0.21);
    font-size: 12px;
    color: #067cf2;
    padding: 10px 5px;
    border-radius: 4px;
    position: relative;
    p {
      color: #fff;
      position: absolute;
      left: 20px;
      top: -12px;
      font-size: 20px;
      transform: rotate(180deg);
    }
  }

  .aside-goodsno {
    font-family: 'font-Light';
    margin-top: 10px;
    .goods-input {
      position: relative;
      input {
        width: 270px;
        border: none;
        outline: none;
        background: #fff;
        box-shadow: 0px 2px 10px 0px rgba(6, 124, 242, 0.21);
        border-radius: 4px 0 0 4px;
        height: 36px;
        line-height: 36px;
        padding: 0 18px 0 10px;
        font-size: 16px;
        color: #067cf2;
      }
      input:-moz-placeholder {
        color: #067cf2;
      }
      input::-moz-placeholder {
        color: #067cf2;
      }
      input::-webkit-input-placeholder {
        color: #067cf2;
      }
      input:-ms-input-placeholder {
        color: #067cf2;
      }
      span {
        width: calc(100% - 270px);
        background: #067cf2;
        line-height: 36px;
        color: #fff;
        border-radius: 4px;
        margin-left: -10px;
        text-align: center;
        cursor: pointer;
        i {
          margin-right: 4px;
        }
      }
      .spu-card {
        position: absolute;
        left: 0;
        top: 38px;
        width: 300px;
        background: #fff;
        box-shadow: 0px -1px 6px 0px rgba(0, 0, 0, 0.3);
        color: #333;
        z-index: 99999;
        .spu-card-list {
          margin-top: 34px;
          max-height: 300px;
          overflow: auto;
          .spu-card-title {
            width: 100%;
            position: absolute;
            top: 0;
            z-index: 9;
            background: #eef2fb;
            line-height: 30px;
            font-family: 'font-Regular';
            div {
              width: 130px;
              text-align: center;
              color: #999;
            }
          }
        }
        .spu-list {
          border-bottom: 1px solid #f5f5f5;
          width: 260px;
          line-height: 30px;
          cursor: pointer;
          &:hover {
            background: #eff7ff;
          }
          div {
            width: 130px;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }
    .goods-attr {
      background: #ffffff;
      box-shadow: 0 2px 10px 0 rgba(6, 124, 242, 0.21);
      border-radius: 4px;
      line-height: 36px;
      position: relative;
      padding: 0 10px;
      width: calc((100% - 20px) / 2);
      margin-right: 10px;
      color: #067cf2;
      > i {
        color: #000;
        font-weight: bold;
      }
      .list-card {
        position: absolute;
        top: 38px;
        left: 0;
        width: 185px;
        box-shadow: 0px -1px 6px 0px rgba(0, 0, 0, 0.3);
        background: #fff;
        border-radius: 4px;
        text-align: center;
        z-index: 9999;
        > div {
          border-bottom: 1px solid #eee;
          cursor: pointer;
          &:last-child {
            border-bottom: none;
          }
          &:hover {
            background: #eff7ff;
          }
        }
      }
    }
  }

  .stock-sales {
    margin-top: 10px;
    div {
      width: calc((100% - 20px) / 2);
      box-shadow: 0px 3px 8px 0px rgba(204, 204, 204, 0.54);
      border-radius: 4px;
      background: #d2e5fe;
      height: 60px;
      cursor: pointer;
      margin-bottom: 10px;
      margin-right: 10px;
      p {
        font-size: 16px;
        color: #08397c;
        margin-top: 10px;
      }
      span {
        font-size: 14px;
        color: #fff;
      }
    }
    .none-margin-right {
      margin-right: 0;
    }
  }

  .ned-class {
    font-size: 14px;
    padding: 10px;
    padding-top: 5px;
    background-color: white;
    border: 1px solid #ffd591;
    .top {
      display: flex;
      align-items: center;
      font-weight: 600;
      img {
        width: 25px;
        height: 25px;
        margin-right: 5px;
      }
    }
    .center {
      margin: 5px 0;
      margin-bottom: 10px;
    }
    .bottom {
    }
  }

  .sales-ording {
    font-size: 14px;
    .item-card {
      width: calc((100% - 10px) / 2);
      position: relative;
      .item-value {
        box-shadow: 0px 2px 10px 0px rgba(6, 124, 242, 0.21);
        border-radius: 4px;
        height: 32px;
        line-height: 32px;
        width: 100%;
        background: #fff;
        padding: 0 10px;
        i {
          color: #999;
        }
        input {
          width: 100%;
          line-height: 30px;
          height: 32px;
          outline: none;
          border: none;
          background: none;
        }
      }
      .item-options {
        position: absolute;
        top: 34px;
        left: 0;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0px 2px 10px 0px rgba(6, 124, 242, 0.21);
        width: 100%;
        z-index: 9;
        div {
          line-height: 34px;
          padding: 0 5px;
          cursor: pointer;
          &:hover {
            background: #eff7ff;
          }
        }
      }
      .user-option {
        left: 0;
        width: 100%;
        max-height: 300px;
        overflow: auto;
        background: #fff;
        .search-user {
          padding: 10px 5px;
          border-bottom: 1px solid #f5f5f5;
          cursor: pointer;
          .user-avat {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 10px;
            .image {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              float: left;
              margin-right: 10px;
            }
            > div {
              color: #fff;
              font-size: 20px;
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: #067cf2;
              text-align: center;
              line-height: 40px;
            }
          }
          .user-data {
            height: 40px;
            line-height: 20px;
          }
        }
      }
    }
    .show-allshop {
      line-height: 32px;
      border-radius: 4px;
      background: #067cf2;
      color: #fff;
      text-align: center;
      cursor: pointer;
      box-shadow: 0px 2px 10px 0px rgba(6, 124, 242, 0.21);
    }
  }

  .ganger-user {
    font-size: 14px;
    margin-top: 10px;
    color: #999;
    line-height: 24px;
  }

  .team-card {
    background: #fef3e4;
    border: 1px solid #ffffff;
    border-radius: 4px;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    .show-user {
      border-radius: 4px;
      font-size: 14px;
      background: rgb(255, 213, 145);
      line-height: 26px;
      padding: 0 10px;
      cursor: pointer;
    }
  }

  .team-card-old {
    background: #fef3e4;
    border: 1px solid #ffffff;
    border-radius: 4px;
    margin-top: 10px;
    padding: 5px;
    > p {
      margin-bottom: 8px;
      i {
        color: orange;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .team-item {
      span {
        &:first-child {
          margin-bottom: 5px;
          color: #000;
          font-weight: bold;
        }
        &:last-child {
          color: #999;
        }
      }
      i {
        width: 1px;
        height: 25px;
        background: #f3ddc0;
      }
    }
  }

  .vip-card {
    width: 100%;
    font-size: 14px;
    background: #fef3e4;
    border: 1px solid #ffffff;
    border-radius: 4px;
    margin-top: 10px;
    height: 54px;
    p {
      span {
        &:first-child {
          color: #492a00;
          font-size: 16px;
          font-weight: bold;
        }
        &:last-child {
          color: #999;
          margin-top: 5px;
        }
      }
    }
    > i {
      width: 1px;
      height: 25px;
      background: #f3ddc0;
    }
    > span {
      border: 1px solid #ff9f52;
      color: #ff9f52;
      border-radius: 4px;
      padding: 0 4px;
      cursor: pointer;
    }
    .column{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }
    .vip-default {
      height: 40px;
      line-height: 40px;
      border: 1px solid orange;
      border-radius: 2px;
      padding-left: 10px;
      font-size: 16px;
      background: #fff;
      margin-left: 10px;
      display: flex;
      > i {
        font-size: 20px;
        font-weight: bold;
        color: orange;
      }
      > input {
        width: 190px;
        line-height: 36px;
        height: 36px;
        outline: none;
        margin-left: 10px;
        font-size: 16px;
        float: right;
        border: none;
        margin-top: 2px;
        background: none;
        color: orange;
        padding-right: 10px;
      }
      input::-webkit-input-placeholder {
        color: orange;
      }
      input:focus {
        color: #c56209;
      }
      input:focus::-webkit-input-placeholder {
        color: #c56209;
      }
    }
    .vip-tip-text {
      margin-left: 6px;
      color: orange;
    }
  }

  .about-price {
    height: 270px;
    overflow-y:scroll ;
    .price-line{
      margin-bottom: 15px;
      .label-span{
        color: #999;
      }
      .value-p{
        color: #f8475f;
        font-size: 40px;
      }
      .value-i{
        font-size: 16px;
        margin-left: 5px;
        font-style: normal;
      }
    }
  }

  .aside-end {
    position: fixed;
    bottom: 20px;
    width: 400px;
    height: 76px;
    .aside-finally {
      flex: 1;
      color: #fff;
      cursor: pointer;
      position: relative;
    }
    .pay-btn-txt {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      transform: translate(-50%, -50%);
      div{
        font-size: 24px;
      }
      p{
        color: #ddd;
        font-size: 14px;
      }
    }
  }
}
</style>

<style>
.main-info .table-wrap {
  height: calc(100vh - 180px) !important;
}
.main-info .highlight-bg td {
  background: #fff8ef !important;
}
.main-info tbody tr[gm-cache-key='0'] td {
  border-top: 3px dashed #067cf2 !important;
  border-bottom: 3px dashed #067cf2 !important;
}
.main-info .gm-remind-action i {
  left: 56px;
  color: #000;
}
</style>
